import React from 'react';

import sustainabilityIcons from './sustainabilityIcons';

const icons = {
  ...sustainabilityIcons,
  ideationActive: (
    <svg
      width="30"
      height="30"
      viewBox="0 0 30 30"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M2 5C0.895431 5 0 5.89543 0 7V28C0 29.1046 0.89543 30 2 30H28C29.1046 30 30 29.1046 30 28V7C30 5.89543 29.1046 5 28 5H2ZM3.99911 7.00002C2.89455 7.00002 2 7.89545 2 9.00002V26C2 27.1046 2.89543 28 4 28H26C27.1046 28 28 27.1046 28 26V9.00002C28 7.89545 27.1046 7.00002 26 7.00002L22 7V5.00003H8V7L3.99911 7.00002Z"
        fill="#0984FF"
      />
      <path d="M7 20H23" stroke="#0984FF" strokeLinecap="round" />
      <path d="M9 24H21" stroke="#0984FF" strokeLinecap="round" />
      <g clipPath="url(#clip0)">
        <path
          d="M16.0002 15.9999H14.0002C13.5335 15.9999 13.0002 15.5999 13.0002 14.7999V13.3999C13.0002 12.7333 12.6668 12.1333 12.1335 11.6666C10.9335 10.7333 10.3335 9.39994 10.3335 7.93328C10.4002 5.39994 12.4668 3.39994 14.9335 3.33327C16.2002 3.33327 17.4002 3.79994 18.2668 4.66661C19.1335 5.53328 19.6668 6.73327 19.6668 7.99994C19.6668 9.39994 19.0668 10.7333 17.9335 11.5999C17.3335 12.0666 17.0002 12.7999 17.0002 13.4666V14.9999C17.0002 15.5333 16.5335 15.9999 16.0002 15.9999ZM15.0002 3.99994C12.8668 3.99994 11.0668 5.79994 11.0002 7.93328C11.0002 9.19994 11.5335 10.3999 12.5335 11.1333C13.2668 11.7333 13.6668 12.5333 13.6668 13.3999V14.7999C13.6668 14.9333 13.6668 15.3333 14.0002 15.3333H16.0002C16.2002 15.3333 16.3335 15.1999 16.3335 14.9999V13.4666C16.3335 12.5999 16.8002 11.6666 17.5335 11.0666C18.4668 10.3333 19.0002 9.19994 19.0002 7.99994C19.0002 6.93327 18.6002 5.93327 17.8002 5.13327C17.0668 4.39994 16.0668 3.99994 15.0002 3.99994Z"
          fill="#0984FF"
        />
        <path
          d="M16.6667 14H13.3333C13.1333 14 13 13.8667 13 13.6667C13 13.4667 13.1333 13.3333 13.3333 13.3333H16.6667C16.8667 13.3333 17 13.4667 17 13.6667C17 13.8667 16.8667 14 16.6667 14Z"
          fill="#0984FF"
        />
        <path
          d="M14.9998 1.99999C14.7998 1.99999 14.6665 1.86666 14.6665 1.66666V0.333326C14.6665 0.133326 14.7998 -7.62939e-06 14.9998 -7.62939e-06C15.1998 -7.62939e-06 15.3332 0.133326 15.3332 0.333326V1.66666C15.3332 1.86666 15.1998 1.99999 14.9998 1.99999Z"
          fill="#0984FF"
        />
        <path
          d="M19.4665 3.86662C19.3999 3.86662 19.2665 3.86662 19.1999 3.79996C19.0665 3.66662 19.0665 3.46662 19.1999 3.33329L20.1332 2.39996C20.2665 2.26662 20.4665 2.26662 20.5999 2.39996C20.7332 2.53329 20.7332 2.73329 20.5999 2.86662L19.6665 3.79996C19.6665 3.79996 19.5332 3.86662 19.4665 3.86662Z"
          fill="#0984FF"
        />
        <path
          d="M10.5334 3.86668C10.4667 3.86668 10.3334 3.86668 10.2667 3.80001L9.3334 2.80001C9.20007 2.66668 9.20007 2.46668 9.3334 2.33335C9.46673 2.20001 9.66673 2.20001 9.80006 2.33335L10.7334 3.26668C10.8667 3.40001 10.8667 3.60001 10.7334 3.73334C10.6667 3.80001 10.6001 3.86668 10.5334 3.86668Z"
          fill="#0984FF"
        />
      </g>
      <defs>
        <clipPath id="clip0">
          <rect width="16" height="16" fill="white" transform="translate(7)" />
        </clipPath>
      </defs>
    </svg>
  ),
  ideation: (
    <svg
      width="30"
      height="30"
      viewBox="0 0 30 30"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M2 5C0.895431 5 0 5.89543 0 7V28C0 29.1046 0.89543 30 2 30H28C29.1046 30 30 29.1046 30 28V7C30 5.89543 29.1046 5 28 5H2ZM3.99911 7.00002C2.89455 7.00002 2 7.89545 2 9.00002V26C2 27.1046 2.89543 28 4 28H26C27.1046 28 28 27.1046 28 26V9.00002C28 7.89545 27.1046 7.00002 26 7.00002L22 7V5.00003H8V7L3.99911 7.00002Z"
        fill="white"
      />
      <path d="M7 20H23" stroke="white" strokeLinecap="round" />
      <path d="M9 24H21" stroke="white" strokeLinecap="round" />
      <g clipPath="url(#clip0)">
        <path
          d="M15.9946 15.9999H13.9953C13.5288 15.9999 12.9957 15.5999 12.9957 14.7999V13.3999C12.9957 12.7333 12.6625 12.1333 12.1293 11.6666C10.9297 10.7333 10.33 9.39994 10.33 7.93328C10.3966 5.39994 12.4625 3.39994 14.9283 3.33327C16.1945 3.33327 17.3941 3.79994 18.2605 4.66661C19.1268 5.53328 19.66 6.73327 19.66 7.99994C19.66 9.39994 19.0602 10.7333 17.9272 11.5999C17.3275 12.0666 16.9942 12.7999 16.9942 13.4666V14.9999C16.9942 15.5333 16.5277 15.9999 15.9946 15.9999ZM14.995 3.99994C12.8624 3.99994 11.063 5.79994 10.9964 7.93328C10.9964 9.19994 11.5295 10.3999 12.5292 11.1333C13.2622 11.7333 13.6621 12.5333 13.6621 13.3999V14.7999C13.6621 14.9333 13.6621 15.3333 13.9953 15.3333H15.9946C16.1945 15.3333 16.3278 15.1999 16.3278 14.9999V13.4666C16.3278 12.5999 16.7943 11.6666 17.5274 11.0666C18.4604 10.3333 18.9935 9.19994 18.9935 7.99994C18.9935 6.93327 18.5937 5.93327 17.794 5.13327C17.0609 4.39994 16.0612 3.99994 14.995 3.99994Z"
          fill="white"
        />
        <path
          d="M16.6667 14H13.3333C13.1333 14 13 13.8667 13 13.6667C13 13.4667 13.1333 13.3333 13.3333 13.3333H16.6667C16.8667 13.3333 17 13.4667 17 13.6667C17 13.8667 16.8667 14 16.6667 14Z"
          fill="white"
        />
        <path
          d="M14.9998 1.99999C14.7998 1.99999 14.6665 1.86666 14.6665 1.66666V0.333326C14.6665 0.133326 14.7998 -7.62939e-06 14.9998 -7.62939e-06C15.1998 -7.62939e-06 15.3332 0.133326 15.3332 0.333326V1.66666C15.3332 1.86666 15.1998 1.99999 14.9998 1.99999Z"
          fill="white"
        />
        <path
          d="M19.4665 3.86662C19.3999 3.86662 19.2665 3.86662 19.1999 3.79996C19.0665 3.66662 19.0665 3.46662 19.1999 3.33329L20.1332 2.39996C20.2665 2.26662 20.4665 2.26662 20.5999 2.39996C20.7332 2.53329 20.7332 2.73329 20.5999 2.86662L19.6665 3.79996C19.6665 3.79996 19.5332 3.86662 19.4665 3.86662Z"
          fill="white"
        />
        <path
          d="M10.5334 3.86668C10.4667 3.86668 10.3334 3.86668 10.2667 3.80001L9.3334 2.80001C9.20007 2.66668 9.20007 2.46668 9.3334 2.33335C9.46673 2.20001 9.66673 2.20001 9.80006 2.33335L10.7334 3.26668C10.8667 3.40001 10.8667 3.60001 10.7334 3.73334C10.6667 3.80001 10.6001 3.86668 10.5334 3.86668Z"
          fill="white"
        />
      </g>
      <defs>
        <clipPath id="clip0">
          <rect width="16" height="16" fill="white" transform="translate(7)" />
        </clipPath>
      </defs>
    </svg>
  ),
  canvasActive: (
    <svg
      width="30"
      height="30"
      viewBox="0 0 30 30"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect x="0.5" y="4.5" width="4" height="13" rx="0.5" stroke="#0984FF" />
      <rect x="0.5" y="19.5" width="8" height="6" rx="0.5" stroke="#0984FF" />
      <rect x="6.5" y="4.5" width="4" height="5.5" rx="0.5" stroke="#0984FF" />
      <rect x="6.5" y="12" width="4" height="5.5" rx="0.5" stroke="#0984FF" />
      <rect x="10.5" y="19.5" width="9" height="6" rx="0.5" stroke="#0984FF" />
      <rect x="12.5" y="4.5" width="5" height="13" rx="0.5" stroke="#0984FF" />
      <rect x="21.5" y="19.5" width="8" height="6" rx="0.5" stroke="#0984FF" />
      <rect x="19.5" y="4.5" width="4" height="5.5" rx="0.5" stroke="#0984FF" />
      <rect x="19.5" y="12" width="4" height="5.5" rx="0.5" stroke="#0984FF" />
      <rect
        x="25.5"
        y="4.5"
        width="4"
        height="13"
        rx="0.5"
        fill="#0984FF"
        stroke="#0984FF"
      />
    </svg>
  ),
  canvas: (
    <svg
      width="30"
      height="30"
      viewBox="0 0 30 30"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect x="0.5" y="4.5" width="4" height="13" rx="0.5" stroke="white" />
      <rect x="0.5" y="19.5" width="8" height="6" rx="0.5" stroke="white" />
      <rect x="6.5" y="4.5" width="4" height="5.5" rx="0.5" stroke="white" />
      <rect x="6.5" y="12" width="4" height="5.5" rx="0.5" stroke="white" />
      <rect x="10.5" y="19.5" width="9" height="6" rx="0.5" stroke="white" />
      <rect x="12.5" y="4.5" width="5" height="13" rx="0.5" stroke="white" />
      <rect x="21.5" y="19.5" width="8" height="6" rx="0.5" stroke="white" />
      <rect x="19.5" y="4.5" width="4" height="5.5" rx="0.5" stroke="white" />
      <rect x="19.5" y="12" width="4" height="5.5" rx="0.5" stroke="white" />
      <rect
        x="25.5"
        y="4.5"
        width="4"
        height="13"
        rx="0.5"
        fill="white"
        stroke="white"
      />
    </svg>
  ),
  testingActive: (
    <svg
      width="30"
      height="30"
      viewBox="0 0 30 30"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M4 3C2.89543 3 2 3.89543 2 5V28C2 29.1046 2.89543 30 4 30H25C26.1046 30 27 29.1046 27 28V5C27 3.89543 26.1046 3 25 3H4ZM5 5C4.44772 5 4 5.44772 4 6V27C4 27.5523 4.44772 28 5 28H24C24.5523 28 25 27.5523 25 27V6C25 5.44772 24.5523 5 24 5H5Z"
        fill="#0984FF"
      />
      <rect x="8" y="11" width="9" height="2" rx="1" fill="#0984FF" />
      <rect x="8" y="16" width="9" height="2" rx="1" fill="#0984FF" />
      <rect x="8" y="21" width="9" height="2" rx="1" fill="#0984FF" />
      <path
        d="M19 22.2222L19.6087 23L21 21"
        stroke="#0984FF"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M13 0C11.8954 0 11 0.89543 11 2V6C11 6.55228 11.4477 7 12 7H17C17.5523 7 18 6.55228 18 6V2C18 0.895431 17.1046 0 16 0H13ZM14.5 2C14.7761 2 15 1.77614 15 1.5C15 1.22386 14.7761 1 14.5 1C14.2239 1 14 1.22386 14 1.5C14 1.77614 14.2239 2 14.5 2Z"
        fill="#0984FF"
      />
      <path
        d="M19 12H21"
        stroke="#0984FF"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M19 16L20 17M21 18L20 17M20 17L21 16L19 18"
        stroke="#0984FF"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  testing: (
    <svg
      width="30"
      height="30"
      viewBox="0 0 30 30"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M4 3C2.89543 3 2 3.89543 2 5V28C2 29.1046 2.89543 30 4 30H25C26.1046 30 27 29.1046 27 28V5C27 3.89543 26.1046 3 25 3H4ZM5 5C4.44772 5 4 5.44772 4 6V27C4 27.5523 4.44772 28 5 28H24C24.5523 28 25 27.5523 25 27V6C25 5.44772 24.5523 5 24 5H5Z"
        fill="white"
      />
      <rect x="8" y="11" width="9" height="2" rx="1" fill="white" />
      <rect x="8" y="16" width="9" height="2" rx="1" fill="white" />
      <rect x="8" y="21" width="9" height="2" rx="1" fill="white" />
      <path
        d="M19 22.2222L19.6087 23L21 21"
        stroke="white"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M13 0C11.8954 0 11 0.89543 11 2V6C11 6.55228 11.4477 7 12 7H17C17.5523 7 18 6.55228 18 6V2C18 0.895431 17.1046 0 16 0H13ZM14.5 2C14.7761 2 15 1.77614 15 1.5C15 1.22386 14.7761 1 14.5 1C14.2239 1 14 1.22386 14 1.5C14 1.77614 14.2239 2 14.5 2Z"
        fill="white"
      />
      <path
        d="M19 12H21"
        stroke="white"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M19 16L20 17M21 18L20 17M20 17L21 16L19 18"
        stroke="white"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  portfolioActive: (
    <svg
      width="30"
      height="27"
      viewBox="0 0 30 27"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M2 0C0.895431 0 0 0.895431 0 2V18C0 19.1046 0.89543 20 2 20H28C29.1046 20 30 19.1046 30 18V2C30 0.895431 29.1046 0 28 0H2ZM3 2C2.44772 2 2 2.44772 2 3V17C2 17.5523 2.44772 18 3 18H27C27.5523 18 28 17.5523 28 17V3C28 2.44772 27.5523 2 27 2H3Z"
        fill="#0984FF"
      />
      <path
        d="M15 22V26M15 22L19 26M15 22L11 26"
        stroke="#0984FF"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path d="M16 5H24" stroke="#0984FF" strokeLinecap="round" />
      <path d="M16 7H22" stroke="#0984FF" strokeLinecap="round" />
      <path d="M16 9H24" stroke="#0984FF" strokeLinecap="round" />
      <path d="M16 11H20" stroke="#0984FF" strokeLinecap="round" />
      <rect x="4" y="4" width="9" height="9" rx="1" fill="#0984FF" />
    </svg>
  ),
  portfolio: (
    <svg
      width="30"
      height="30"
      viewBox="0 0 30 30"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M2 2C0.895431 2 0 2.89543 0 4V20C0 21.1046 0.89543 22 2 22H28C29.1046 22 30 21.1046 30 20V4C30 2.89543 29.1046 2 28 2H2ZM3 4C2.44772 4 2 4.44772 2 5V19C2 19.5523 2.44772 20 3 20H27C27.5523 20 28 19.5523 28 19V5C28 4.44772 27.5523 4 27 4H3Z"
        fill="white"
      />
      <path
        d="M15 24V28M15 24L19 28M15 24L11 28"
        stroke="white"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path d="M16 7H24" stroke="white" strokeLinecap="round" />
      <path d="M16 9H22" stroke="white" strokeLinecap="round" />
      <path d="M16 11H24" stroke="white" strokeLinecap="round" />
      <path d="M16 13H20" stroke="white" strokeLinecap="round" />
      <rect x="4" y="6" width="9" height="9" rx="1" fill="white" />
    </svg>
  ),
  valueProposition: (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M20 12V22H4V12"
        stroke="#00AFC9"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M22 7H2V12H22V7Z"
        stroke="#00AFC9"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12 22V7"
        stroke="#00AFC9"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12 7H16.5C17.163 7 17.7989 6.73661 18.2678 6.26777C18.7366 5.79893 19 5.16304 19 4.5C19 3.83696 18.7366 3.20107 18.2678 2.73223C17.7989 2.26339 17.163 2 16.5 2C13 2 12 7 12 7Z"
        stroke="#00AFC9"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12 7H7.5C6.83696 7 6.20107 6.73661 5.73223 6.26777C5.26339 5.79893 5 5.16304 5 4.5C5 3.83696 5.26339 3.20107 5.73223 2.73223C6.20107 2.26339 6.83696 2 7.5 2C11 2 12 7 12 7Z"
        stroke="#00AFC9"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  gkg: (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M18.6891 6.32611C18.2738 5.90569 17.7806 5.57219 17.2377 5.34465C16.6949 5.11711 16.1131 5 15.5255 5C14.9379 5 14.3561 5.11711 13.8133 5.34465C13.2704 5.57219 12.7772 5.90569 12.3619 6.32611L11.4998 7.19821L10.6377 6.32611C9.79866 5.4773 8.66066 5.00044 7.47407 5.00044C6.28747 5.00044 5.14947 5.4773 4.31042 6.32611C3.47137 7.17492 3 8.32616 3 9.52656C3 10.727 3.47137 11.8782 4.31042 12.727L5.1725 13.5991L11.4998 20L17.8271 13.5991L18.6891 12.727C19.1047 12.3068 19.4344 11.8079 19.6593 11.2587C19.8842 10.7096 20 10.121 20 9.52656C20 8.93214 19.8842 8.34355 19.6593 7.7944C19.4344 7.24526 19.1047 6.74633 18.6891 6.32611V6.32611Z"
        stroke="#00AFC9"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  puzzles: (
    <svg
      width="36"
      height="36"
      viewBox="0 0 36 36"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M6.45828 22.4375C5.2792 22.4375 4.31995 23.3967 4.31995 24.5758C4.31995 25.7549 5.2792 26.7141 6.45828 26.7141V29.0128C6.45828 29.3081 6.69762 29.5474 6.99287 29.5474H15.867C16.1622 29.5474 16.4015 29.3081 16.4015 29.0128V26.0812C16.4015 25.9074 16.317 25.7444 16.175 25.6443C16.033 25.5441 15.8511 25.5193 15.6875 25.5777C15.5604 25.6229 15.4443 25.645 15.3324 25.645C14.7428 25.645 14.2632 25.1653 14.2632 24.5758C14.2632 23.9863 14.7428 23.5066 15.3324 23.5066C15.4443 23.5066 15.5604 23.5286 15.6875 23.5739C15.8512 23.6324 16.0331 23.6074 16.175 23.5073C16.3171 23.4071 16.4015 23.2442 16.4015 23.0704V20.1387C16.4015 19.8435 16.1622 19.6042 15.867 19.6042H13.5683C13.5683 18.4251 12.609 17.4658 11.4299 17.4658C10.2508 17.4658 9.29158 18.4251 9.29158 19.6042H6.99287C6.69762 19.6042 6.45828 19.8435 6.45828 20.1387V22.4375ZM6.81335 23.5739C6.9771 23.6324 7.15896 23.6074 7.30095 23.5073C7.44299 23.4071 7.52745 23.2442 7.52745 23.0704V20.6733H9.92453C10.0983 20.6733 10.2613 20.5888 10.3614 20.4468C10.4616 20.3048 10.4864 20.1229 10.4281 19.9592C10.3828 19.8322 10.3607 19.716 10.3607 19.6042C10.3607 19.0146 10.8404 18.535 11.4299 18.535C12.0195 18.535 12.4991 19.0146 12.4991 19.6042C12.4991 19.716 12.4771 19.8322 12.4318 19.9592C12.3734 20.1229 12.3983 20.3048 12.4984 20.4468C12.5986 20.5889 12.7615 20.6733 12.9353 20.6733H15.3324V22.4375C14.1533 22.4375 13.194 23.3967 13.194 24.5758C13.194 25.7549 14.1533 26.7141 15.3324 26.7141V28.4783H7.52745V26.0812C7.52745 25.9074 7.44293 25.7444 7.30095 25.6443C7.15891 25.5441 6.97704 25.5193 6.81335 25.5777C6.68634 25.6229 6.57017 25.645 6.45828 25.645C5.86874 25.645 5.38911 25.1653 5.38911 24.5758C5.38911 23.9863 5.86874 23.5066 6.45828 23.5066C6.57017 23.5066 6.68634 23.5286 6.81335 23.5739Z"
        fill="white"
      />
      <path
        d="M29.5464 9.29081V6.9921C29.5464 6.69685 29.3071 6.45752 29.0118 6.45752H20.1377C19.8425 6.45752 19.6031 6.69685 19.6031 6.9921V9.92376C19.6031 10.0976 19.6877 10.2605 19.8297 10.3607C19.9717 10.4608 20.1536 10.4857 20.3172 10.4273C20.4443 10.382 20.5604 10.36 20.6723 10.36C21.2619 10.36 21.7415 10.8396 21.7415 11.4292C21.7415 12.0187 21.2619 12.4983 20.6723 12.4983C20.5604 12.4983 20.4443 12.4763 20.3172 12.431C20.1536 12.3726 19.9717 12.3975 19.8297 12.4976C19.6876 12.5978 19.6031 12.7607 19.6031 12.9345V15.8662C19.6031 16.1614 19.8425 16.4008 20.1377 16.4008H22.4364C22.4364 17.5799 23.3957 18.5391 24.5748 18.5391C25.7539 18.5391 26.7131 17.5799 26.7131 16.4008H29.0118C29.3071 16.4008 29.5464 16.1614 29.5464 15.8662V13.5675C30.7255 13.5675 31.6847 12.6082 31.6847 11.4292C31.6847 10.2501 30.7255 9.29081 29.5464 9.29081ZM29.5464 12.4983C29.4345 12.4983 29.3184 12.4763 29.1913 12.431C29.0276 12.3726 28.8458 12.3975 28.7037 12.4976C28.5617 12.5978 28.4772 12.7607 28.4772 12.9345V15.3316H26.0802C25.9064 15.3316 25.7434 15.4161 25.6433 15.5581C25.5431 15.7002 25.5183 15.882 25.5766 16.0457C25.6219 16.1727 25.6439 16.2888 25.6439 16.4008C25.6439 16.9903 25.1643 17.4699 24.5748 17.4699C23.9852 17.4699 23.5056 16.9903 23.5056 16.4008C23.5056 16.2889 23.5276 16.1727 23.5729 16.0457C23.6313 15.882 23.6064 15.7002 23.5063 15.5581C23.4061 15.4161 23.2432 15.3316 23.0694 15.3316H20.6723V13.5675C21.8514 13.5675 22.8107 12.6082 22.8107 11.4292C22.8107 10.2501 21.8514 9.29081 20.6723 9.29081V7.52669H28.4772V9.92376C28.4772 10.0976 28.5618 10.2605 28.7037 10.3607C28.8458 10.4608 29.0276 10.4857 29.1913 10.4273C29.3184 10.382 29.4345 10.36 29.5464 10.36C30.1359 10.36 30.6156 10.8396 30.6156 11.4292C30.6156 12.0187 30.1359 12.4983 29.5464 12.4983Z"
        fill="white"
      />
      <path
        d="M15.8662 6.45816H13.5675C13.5675 5.27908 12.6082 4.31982 11.4292 4.31982C10.2501 4.31982 9.29082 5.27908 9.29082 6.45816H6.9921C6.69685 6.45816 6.45752 6.69749 6.45752 6.99275V15.8668C6.45752 16.1621 6.69685 16.4014 6.9921 16.4014H9.92376C10.0976 16.4014 10.2605 16.3169 10.3607 16.1749C10.4608 16.0329 10.4857 15.851 10.4273 15.6873C10.382 15.5603 10.36 15.4441 10.36 15.3323C10.36 14.7427 10.8396 14.2631 11.4292 14.2631C12.0187 14.2631 12.4983 14.7427 12.4983 15.3323C12.4983 15.4441 12.4763 15.5603 12.431 15.6873C12.3726 15.851 12.3975 16.0329 12.4976 16.1749C12.5978 16.317 12.7607 16.4014 12.9345 16.4014H15.8662C16.1615 16.4014 16.4008 16.1621 16.4008 15.8668V13.5681C17.5799 13.5681 18.5391 12.6089 18.5391 11.4298C18.5391 10.2507 17.5799 9.29146 16.4008 9.29146V6.99275C16.4008 6.69749 16.1615 6.45816 15.8662 6.45816ZM17.47 11.4298C17.47 12.0193 16.9903 12.499 16.4008 12.499C16.2889 12.499 16.1727 12.4769 16.0457 12.4317C15.882 12.3733 15.7002 12.3981 15.5581 12.4983C15.4161 12.5984 15.3316 12.7614 15.3316 12.9352V15.3323H13.5675C13.5675 14.1532 12.6082 13.1939 11.4292 13.1939C10.2501 13.1939 9.29082 14.1532 9.29082 15.3323H7.52669V7.52733H9.92376C10.0976 7.52733 10.2605 7.44281 10.3607 7.30083C10.4608 7.15879 10.4857 6.97692 10.4273 6.81323C10.382 6.68621 10.36 6.57005 10.36 6.45816C10.36 5.86862 10.8396 5.38899 11.4292 5.38899C12.0187 5.38899 12.4983 5.86862 12.4983 6.45816C12.4983 6.57005 12.4763 6.68621 12.431 6.81323C12.3726 6.97692 12.3975 7.15879 12.4976 7.30083C12.5978 7.44287 12.7607 7.52733 12.9345 7.52733H15.3316V9.9244C15.3316 10.0982 15.4161 10.2611 15.5581 10.3613C15.7002 10.4614 15.882 10.4864 16.0457 10.4279C16.1727 10.3827 16.2888 10.3606 16.4008 10.3606C16.9903 10.3606 17.47 10.8403 17.47 11.4298Z"
        fill="white"
      />
      <path
        d="M23.5071 19.8295C23.4069 19.6875 23.2439 19.603 23.0702 19.603H20.1385C19.8432 19.603 19.6039 19.8424 19.6039 20.1376V22.4363C18.4248 22.4363 17.4656 23.3956 17.4656 24.5747C17.4656 25.7537 18.4248 26.713 19.6039 26.713V29.0117C19.6039 29.307 19.8432 29.5463 20.1385 29.5463H22.4372C22.4372 30.7254 23.3965 31.6846 24.5755 31.6846C25.7546 31.6846 26.7139 30.7254 26.7139 29.5463H29.0126C29.3078 29.5463 29.5472 29.307 29.5472 29.0117V26.9803C29.5472 26.685 29.3078 26.4457 29.0126 26.4457C28.7173 26.4457 28.478 26.685 28.478 26.9803V28.4771H26.0809C25.9071 28.4771 25.7442 28.5616 25.644 28.7036C25.5439 28.8457 25.519 29.0275 25.5774 29.1912C25.6227 29.3182 25.6447 29.4343 25.6447 29.5463C25.6447 30.1358 25.1651 30.6155 24.5755 30.6155C23.986 30.6155 23.5064 30.1358 23.5064 29.5463C23.5064 29.4344 23.5284 29.3182 23.5737 29.1912C23.6321 29.0275 23.6072 28.8457 23.5071 28.7036C23.4069 28.5616 23.2439 28.4771 23.0702 28.4771H20.6731V26.08C20.6731 25.9063 20.5886 25.7433 20.4466 25.6431C20.3045 25.543 20.1227 25.5181 19.959 25.5765C19.832 25.6218 19.7158 25.6438 19.6039 25.6438C19.0144 25.6438 18.5347 25.1642 18.5347 24.5747C18.5347 23.9851 19.0144 23.5055 19.6039 23.5055C19.7158 23.5055 19.832 23.5275 19.959 23.5728C20.1227 23.6313 20.3046 23.6063 20.4466 23.5062C20.5886 23.406 20.6731 23.2431 20.6731 23.0693V20.6722H22.4372C22.4372 21.8513 23.3965 22.8105 24.5755 22.8105C25.7546 22.8105 26.7139 21.8513 26.7139 20.6722H28.478V22.169C28.478 22.4643 28.7173 22.7036 29.0126 22.7036C29.3078 22.7036 29.5472 22.4643 29.5472 22.169V20.1376C29.5472 19.8424 29.3078 19.603 29.0126 19.603H26.0809C25.9071 19.603 25.7442 19.6875 25.644 19.8295C25.5439 19.9716 25.519 20.1534 25.5774 20.3171C25.6227 20.4441 25.6447 20.5603 25.6447 20.6722C25.6447 21.2617 25.1651 21.7414 24.5755 21.7414C23.986 21.7414 23.5064 21.2617 23.5064 20.6722C23.5064 20.5603 23.5284 20.4441 23.5737 20.3171C23.6321 20.1534 23.6072 19.9716 23.5071 19.8295Z"
        fill="white"
      />
    </svg>
  ),
  people: (
    <svg
      width="25"
      height="25"
      viewBox="0 0 25 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12.3 12.22C12.8336 11.7581 13.2616 11.1869 13.5549 10.545C13.8482 9.90316 14 9.20571 14 8.5C14 7.17392 13.4732 5.90215 12.5355 4.96447C11.5979 4.02678 10.3261 3.5 9 3.5C7.67392 3.5 6.40215 4.02678 5.46447 4.96447C4.52678 5.90215 4 7.17392 4 8.5C3.99999 9.20571 4.1518 9.90316 4.44513 10.545C4.73845 11.1869 5.16642 11.7581 5.7 12.22C4.30014 12.8539 3.11247 13.8775 2.27898 15.1685C1.4455 16.4596 1.00147 17.9633 1 19.5C1 19.7652 1.10536 20.0196 1.29289 20.2071C1.48043 20.3946 1.73478 20.5 2 20.5C2.26522 20.5 2.51957 20.3946 2.70711 20.2071C2.89464 20.0196 3 19.7652 3 19.5C3 17.9087 3.63214 16.3826 4.75736 15.2574C5.88258 14.1321 7.4087 13.5 9 13.5C10.5913 13.5 12.1174 14.1321 13.2426 15.2574C14.3679 16.3826 15 17.9087 15 19.5C15 19.7652 15.1054 20.0196 15.2929 20.2071C15.4804 20.3946 15.7348 20.5 16 20.5C16.2652 20.5 16.5196 20.3946 16.7071 20.2071C16.8946 20.0196 17 19.7652 17 19.5C16.9985 17.9633 16.5545 16.4596 15.721 15.1685C14.8875 13.8775 13.6999 12.8539 12.3 12.22ZM9 11.5C8.40666 11.5 7.82664 11.3241 7.33329 10.9944C6.83994 10.6648 6.45542 10.1962 6.22836 9.64805C6.0013 9.09987 5.94189 8.49667 6.05764 7.91473C6.1734 7.33279 6.45912 6.79824 6.87868 6.37868C7.29824 5.95912 7.83279 5.6734 8.41473 5.55764C8.99667 5.44189 9.59987 5.5013 10.1481 5.72836C10.6962 5.95542 11.1648 6.33994 11.4944 6.83329C11.8241 7.32664 12 7.90666 12 8.5C12 9.29565 11.6839 10.0587 11.1213 10.6213C10.5587 11.1839 9.79565 11.5 9 11.5ZM18.74 11.82C19.38 11.0993 19.798 10.2091 19.9438 9.25634C20.0896 8.30362 19.9569 7.32907 19.5618 6.45C19.1666 5.57093 18.5258 4.8248 17.7165 4.30142C16.9071 3.77805 15.9638 3.49974 15 3.5C14.7348 3.5 14.4804 3.60536 14.2929 3.79289C14.1054 3.98043 14 4.23478 14 4.5C14 4.76522 14.1054 5.01957 14.2929 5.20711C14.4804 5.39464 14.7348 5.5 15 5.5C15.7956 5.5 16.5587 5.81607 17.1213 6.37868C17.6839 6.94129 18 7.70435 18 8.5C17.9986 9.02524 17.8593 9.5409 17.5961 9.99542C17.3328 10.4499 16.9549 10.8274 16.5 11.09C16.3517 11.1755 16.2279 11.2977 16.1404 11.4447C16.0528 11.5918 16.0045 11.7589 16 11.93C15.9958 12.0998 16.0349 12.2678 16.1137 12.4183C16.1924 12.5687 16.3081 12.6967 16.45 12.79L16.84 13.05L16.97 13.12C18.1754 13.6917 19.1923 14.596 19.901 15.7263C20.6096 16.8566 20.9805 18.1659 20.97 19.5C20.97 19.7652 21.0754 20.0196 21.2629 20.2071C21.4504 20.3946 21.7048 20.5 21.97 20.5C22.2352 20.5 22.4896 20.3946 22.6771 20.2071C22.8646 20.0196 22.97 19.7652 22.97 19.5C22.9782 17.9654 22.5938 16.4543 21.8535 15.1101C21.1131 13.7659 20.0413 12.6333 18.74 11.82Z"
        fill="white"
      />
    </svg>
  ),
  gex: (
    <svg
      width="26"
      height="25"
      viewBox="0 0 26 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M13.5 1.04175L23.3958 6.77091V18.2292L13.5 23.9584L3.60413 18.2292V6.77091L13.5 1.04175ZM13.5 3.44904L5.68746 7.97196V17.0282L13.5 21.5511L21.3125 17.0282V7.97196L13.5 3.44904ZM13.5 16.6667C12.3949 16.6667 11.3351 16.2278 10.5537 15.4464C9.77228 14.665 9.33329 13.6051 9.33329 12.5001C9.33329 11.395 9.77228 10.3352 10.5537 9.5538C11.3351 8.7724 12.3949 8.33341 13.5 8.33341C14.605 8.33341 15.6648 8.7724 16.4462 9.5538C17.2276 10.3352 17.6666 11.395 17.6666 12.5001C17.6666 13.6051 17.2276 14.665 16.4462 15.4464C15.6648 16.2278 14.605 16.6667 13.5 16.6667ZM13.5 14.5834C14.0525 14.5834 14.5824 14.3639 14.9731 13.9732C15.3638 13.5825 15.5833 13.0526 15.5833 12.5001C15.5833 11.9475 15.3638 11.4176 14.9731 11.0269C14.5824 10.6362 14.0525 10.4167 13.5 10.4167C12.9474 10.4167 12.4175 10.6362 12.0268 11.0269C11.6361 11.4176 11.4166 11.9475 11.4166 12.5001C11.4166 13.0526 11.6361 13.5825 12.0268 13.9732C12.4175 14.3639 12.9474 14.5834 13.5 14.5834Z"
        fill="white"
      />
    </svg>
  ),
  enter: (
    <svg
      width="26"
      height="25"
      viewBox="0 0 26 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M5.16663 5.20837H7.24996V13.5417H17.8437L15.1562 10.8438L16.625 9.37504L21.8333 14.5834L16.625 19.7917L15.1562 18.323L17.8437 15.625H5.16663V5.20837Z"
        fill="white"
      />
    </svg>
  ),
  userSpeaking: (
    <svg
      width="25"
      height="25"
      viewBox="0 0 25 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M20.0865 4L18.5237 5.46896C19.9837 6.84337 20.7895 8.6697 20.7895 10.6113C20.7895 12.553 19.9837 14.3793 18.5237 15.7537L20.0865 17.2227C21.9655 15.4556 23 13.1077 23 10.6113C23 8.11494 21.9655 5.76711 20.0865 4Z"
        fill="white"
      />
      <path
        d="M16.9597 6.93791L15.3969 8.40895C16.0235 8.9959 16.3684 9.77817 16.3684 10.6113C16.3684 11.4445 16.0235 12.2268 15.3969 12.8137L16.9597 14.2848C18.0031 13.3041 18.5789 12.0003 18.5789 10.6113C18.5789 9.22238 18.0031 7.9186 16.9597 6.93791Z"
        fill="white"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M13.0526 9.57249C13.0526 11.8675 11.0733 13.7279 8.63158 13.7279C6.1899 13.7279 4.21053 11.8675 4.21053 9.57249C4.21053 7.27749 6.1899 5.41703 8.63158 5.41703C11.0733 5.41703 13.0526 7.27749 13.0526 9.57249ZM10.8421 9.57249C10.8421 10.72 9.85242 11.6502 8.63158 11.6502C7.41074 11.6502 6.42105 10.72 6.42105 9.57249C6.42105 8.42499 7.41074 7.49476 8.63158 7.49476C9.85242 7.49476 10.8421 8.42499 10.8421 9.57249Z"
        fill="white"
      />
      <path
        d="M13.0526 21H15.2632C15.2632 17.5575 12.2941 14.7668 8.63158 14.7668C4.96906 14.7668 2 17.5575 2 21H4.21053C4.21053 18.705 6.1899 16.8445 8.63158 16.8445C11.0733 16.8445 13.0526 18.705 13.0526 21Z"
        fill="white"
      />
    </svg>
  ),
  userTooltip: (
    <svg
      width="25"
      height="25"
      viewBox="0 0 25 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M14.6111 8.3C14.6111 9.5096 13.7149 10.4 12.5 10.4C11.2861 10.4 10.3889 9.5096 10.3889 8.3C10.3889 7.0904 11.2861 6.2 12.5 6.2C13.7149 6.2 14.6111 7.0904 14.6111 8.3Z"
        fill="white"
      />
      <path
        d="M8.27778 15.23C8.27778 13.1426 10.1683 11.45 12.5 11.45C14.8317 11.45 16.7222 13.1426 16.7222 15.23V15.6353H8.27778V15.23Z"
        fill="white"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5.11111 2H19.8889C21.0532 2 22 2.94185 22 4.1V17.75C22 18.9081 21.0532 19.85 19.8889 19.85H15.6667L12.5 23L9.33333 19.85H5.11111C3.94683 19.85 3 18.9081 3 17.75V4.1C3 2.94185 3.94683 2 5.11111 2ZM12.5 19.85L14.6111 17.75H19.891L19.8889 4.1H5.11111V17.75H10.3889L12.5 19.85Z"
        fill="white"
      />
    </svg>
  ),
  userCard: (
    <svg
      width="25"
      height="25"
      viewBox="0 0 25 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M9.64378 12.5C11.0825 12.5 12.1438 11.3857 12.1438 9.875C12.1438 8.36431 11.0825 7.25 9.64378 7.25C8.20503 7.25 7.14378 8.36431 7.14378 9.875C7.14378 11.3857 8.20378 12.5 9.64378 12.5Z"
        fill="white"
      />
      <path d="M20 8.5625H15V11.1875H20V8.5625Z" fill="white" />
      <path d="M20 13.8125H16.25V16.4375H20V13.8125Z" fill="white" />
      <path
        d="M9.64375 13.4844C12.1925 13.4844 14.2875 15.9466 14.2875 17.75H5C5 15.9466 7.095 13.4844 9.64375 13.4844Z"
        fill="white"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M22.5 2H2.5C1.12125 2 0 3.10381 0 4.46094V20.5391C0 21.8962 1.12125 23 2.5 23H22.5C23.8787 23 25 21.8962 25 20.5391V4.46094C25 3.10381 23.8787 2 22.5 2ZM22.5 20.375L2.5 20.3606V4.625L22.5 4.63944V20.375Z"
        fill="white"
      />
    </svg>
  ),
  text: (
    <svg
      width="25"
      height="25"
      viewBox="0 0 25 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M2 7.5V5H23V7.5H2Z" fill="white" />
      <path d="M2 13.75H23V11.25H2V13.75Z" fill="white" />
      <path d="M12.5 20H23V17.5H12.5V20Z" fill="white" />
    </svg>
  ),
  okLine: (
    <svg
      width="25"
      height="25"
      viewBox="0 0 25 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M3 19.2857H22V22H3V19.2857Z" fill="white" />
      <path
        d="M18.7293 3L9.78571 11.9436L6.27071 8.44214L4.35714 10.3557L9.78571 15.7843L20.6429 4.92714L18.7293 3Z"
        fill="white"
      />
    </svg>
  ),
  warningTriangle: (
    <svg
      width="25"
      height="25"
      viewBox="0 0 25 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M11.4583 10.4166H13.5417V15.625H11.4583V10.4166Z" fill="white" />
      <path
        d="M12.5 16.6666C11.9247 16.6666 11.4583 17.133 11.4583 17.7083C11.4583 18.2836 11.9247 18.75 12.5 18.75C13.0753 18.75 13.5417 18.2836 13.5417 17.7083C13.5417 17.133 13.0753 16.6666 12.5 16.6666Z"
        fill="white"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M2.84837 21.8771C2.04594 21.8771 1.54484 21.008 1.94688 20.3135L11.5985 3.64256C11.9997 2.94955 13.0003 2.94955 13.4015 3.64256L23.0531 20.3135C23.4551 21.008 22.954 21.8771 22.1516 21.8771H2.84837ZM20.3449 19.7938L12.5 6.2435L4.65509 19.7938H20.3449Z"
        fill="white"
      />
      <path d="M11.4583 16.6666H13.5417V18.75H11.4583V16.6666Z" fill="white" />
    </svg>
  ),
  angryFace: (
    <svg
      width="25"
      height="25"
      viewBox="0 0 25 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12.5 2.08325C6.75626 2.08325 2.08334 6.75617 2.08334 12.4999C2.08334 18.2437 6.75626 22.9166 12.5 22.9166C18.2438 22.9166 22.9167 18.2437 22.9167 12.4999C22.9167 6.75617 18.2438 2.08325 12.5 2.08325ZM12.5 20.8333C7.90522 20.8333 4.16668 17.0947 4.16668 12.4999C4.16668 7.90513 7.90522 4.16659 12.5 4.16659C17.0948 4.16659 20.8333 7.90513 20.8333 12.4999C20.8333 17.0947 17.0948 20.8333 12.5 20.8333Z"
        fill="white"
      />
      <path
        d="M8.85418 12.4999C9.71712 12.4999 10.4167 11.8004 10.4167 10.9374C10.4167 10.0745 9.71712 9.37492 8.85418 9.37492C7.99123 9.37492 7.29168 10.0745 7.29168 10.9374C7.29168 11.8004 7.99123 12.4999 8.85418 12.4999Z"
        fill="white"
      />
      <path
        d="M16.1386 12.4853C16.9975 12.4853 17.6938 11.789 17.6938 10.9301C17.6938 10.0712 16.9975 9.37492 16.1386 9.37492C15.2796 9.37492 14.5833 10.0712 14.5833 10.9301C14.5833 11.789 15.2796 12.4853 16.1386 12.4853Z"
        fill="white"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10.1156 15.2452C10.7446 14.8267 11.5365 14.5833 12.5 14.5833C13.4635 14.5833 14.2554 14.8267 14.8845 15.2452C15.507 15.6595 15.909 16.2043 16.1661 16.7176C16.4211 17.2267 16.5435 17.7233 16.6037 18.0838C16.6342 18.2665 16.6498 18.4211 16.6579 18.534C16.662 18.5906 16.6642 18.6373 16.6653 18.6724C16.6659 18.69 16.6663 18.7047 16.6664 18.7164L16.6666 18.7316L16.6667 18.7374L16.6667 18.7399L16.6667 18.741C16.6667 18.741 16.6667 18.7421 15.625 18.7421C14.5833 18.7421 14.5833 18.7431 14.5833 18.7431L14.5834 18.7456L14.5834 18.7481L14.5834 18.7499L14.5832 18.7417C14.5828 18.7311 14.9297 18.7421 14.5235 18.7421C14.1172 18.7421 14.832 18.7424 14.3828 18.7421C13.9336 18.7418 14.4251 18.7456 14.0235 18.7456C13.6218 18.7456 13.8882 18.7499 13.5352 18.7499C13.1821 18.7499 13.099 18.7499 12.5 18.7499C11.901 18.7499 12.0999 18.7456 11.6328 18.7456C11.1657 18.7456 11.3769 18.7421 11.1016 18.7421C10.8262 18.7421 11.5 18.7456 11 18.7456C10.5 18.7456 10.7606 18.7417 10.4169 18.7417C10.0731 18.7417 10.4172 18.7311 10.4169 18.7417L10.4166 18.7499L10.4167 18.7481L10.4167 18.7456L10.4167 18.744C10.4167 18.744 10.4167 18.7421 9.37501 18.7421C8.33334 18.7421 8.33334 18.741 8.33334 18.741L8.33334 18.7399L8.33335 18.7374L8.33339 18.7316L8.33357 18.7164C8.33376 18.7047 8.3341 18.69 8.33468 18.6724C8.33586 18.6373 8.33804 18.5906 8.34209 18.534C8.35018 18.4211 8.36583 18.2665 8.39634 18.0838C8.45654 17.7233 8.57888 17.2267 8.83394 16.7176C9.09104 16.2043 9.49305 15.6595 10.1156 15.2452Z"
        fill="white"
      />
    </svg>
  ),
  crossedArrows: (
    <svg
      width="25"
      height="25"
      viewBox="0 0 25 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M18.75 11.4583H13.5417V6.24992H16.6667L12.5 2.08325L8.33334 6.24992H11.4583V11.4583H6.25001V8.33325L2.08334 12.4999L6.25001 16.6666V13.5416H11.4583V18.7499H8.33334L12.5 22.9166L16.6667 18.7499H13.5417V13.5416H18.75V16.6666L22.9167 12.4999L18.75 8.33325V11.4583Z"
        fill="white"
      />
    </svg>
  ),
  star: (
    <svg
      width="25"
      height="25"
      viewBox="0 0 25 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5.64676 21.5626C5.92176 22.0761 6.45822 22.397 7.04156 22.3959C7.28739 22.397 7.53114 22.3397 7.74989 22.2292L12.4916 19.7501C12.5041 19.7428 12.5186 19.7386 12.5332 19.7397L17.2426 22.198C17.4707 22.3209 17.7259 22.3845 17.9843 22.3834C18.0666 22.3834 18.1499 22.3761 18.2311 22.3647C19.0791 22.2261 19.6582 21.4324 19.5332 20.5834L18.6166 15.3647C18.6112 15.3571 18.6098 15.3567 18.6094 15.3558C18.6093 15.3555 18.6093 15.3551 18.6093 15.3542C18.6093 15.3511 18.6166 15.3438 18.6166 15.3438L22.4395 11.6459C23.0041 11.1011 23.0759 10.223 22.6061 9.59383C22.3509 9.26467 21.977 9.048 21.5645 8.98967L16.2916 8.22925C16.2822 8.22925 16.2718 8.21883 16.2613 8.20842L13.9061 3.47925C13.6405 2.94487 13.0968 2.60737 12.4999 2.60425C12.327 2.60425 12.1541 2.63133 11.9895 2.68758C11.5947 2.82196 11.2686 3.10529 11.0832 3.47925L8.73114 8.19487C8.73114 8.21675 8.70926 8.22612 8.68843 8.22612L3.42801 8.98654C3.10614 9.04071 2.80614 9.18446 2.56343 9.40321C2.25614 9.70425 2.08322 10.1178 2.08322 10.549C2.08426 10.9584 2.24885 11.3501 2.54155 11.6355L6.39572 15.3438C6.40406 15.3522 6.40718 15.3636 6.40718 15.3751L5.47905 20.573C5.42385 20.9126 5.48322 21.2605 5.64676 21.5626ZM12.4697 4.13237L12.4801 4.12508H12.4999L12.5093 4.13445C12.5186 4.13445 12.527 4.13654 12.5343 4.14279C12.5405 4.14904 12.5436 4.15737 12.5426 4.16675L14.8968 8.87404C15.1228 9.33758 15.5624 9.6605 16.0728 9.73862L21.3457 10.5053C21.3551 10.5053 21.3645 10.5074 21.3728 10.5115C21.378 10.5126 21.3822 10.5126 21.3874 10.5115L21.3978 10.5209L21.3874 10.5438L17.5645 14.2511C17.1843 14.6074 17.0145 15.1345 17.1155 15.6459L18.0332 20.8345L18.0124 20.8542H17.9905C17.9863 20.8563 17.9822 20.8563 17.978 20.8542C17.9676 20.8532 17.9572 20.849 17.9478 20.8438H17.9384L13.2509 18.3959C13.0259 18.2792 12.7759 18.2167 12.5218 18.2178C12.2603 18.2178 12.002 18.2834 11.7707 18.4063L7.05301 20.8803C7.0478 20.8813 7.04155 20.8813 7.03634 20.8803C7.01447 20.8803 6.99572 20.8657 6.99051 20.8449V20.824L7.90718 15.6365C7.99259 15.1292 7.82593 14.6115 7.45926 14.2511L3.60509 10.5532C3.60405 10.5376 3.60614 10.524 3.61447 10.5105L3.67801 10.4897L8.91759 9.73862C9.42801 9.65945 9.86655 9.33758 10.0936 8.87404L12.4488 4.15529C12.4541 4.14591 12.4603 4.13758 12.4697 4.13237Z"
        fill="white"
      />
    </svg>
  ),
  thumbsUp: (
    <svg
      width="25"
      height="25"
      viewBox="0 0 25 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M21.875 8.33342C23.0208 8.33342 23.9583 9.27092 23.9583 10.4167L23.9479 10.5001L23.9583 10.5105V12.5001C23.9583 12.7709 23.9062 13.0209 23.8125 13.2605L20.6667 20.6042C20.3542 21.3542 19.6146 21.8751 18.75 21.8751H9.37499C8.22916 21.8751 7.29166 20.9376 7.29166 19.7917V9.37508C7.29166 8.80217 7.52082 8.28133 7.90624 7.90633L14.7604 1.04175L15.8646 2.1355C16.1458 2.41675 16.3229 2.81258 16.3229 3.23966L16.2917 3.573L15.3021 8.33342H21.875ZM5.20832 21.8751H1.04166V9.37508H5.20832V21.8751Z"
        fill="white"
      />
    </svg>
  ),
  thumbsDown: (
    <svg
      width="25"
      height="25"
      viewBox="0 0 25 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6.24999 3.125H15.625C16.7708 3.125 17.7083 4.0625 17.7083 5.20833V15.625C17.7083 16.1979 17.4792 16.7187 17.1042 17.0937L10.2396 23.9583L9.13541 22.8646C8.85416 22.5833 8.67707 22.1875 8.67707 21.7604L8.70832 21.4271L9.69791 16.6667H3.12499C1.97916 16.6667 1.04166 15.7292 1.04166 14.5833L1.05207 14.5L1.04166 14.4896V12.5C1.04166 12.2292 1.09374 11.9792 1.18749 11.7396L4.33332 4.39583C4.64582 3.64583 5.38541 3.125 6.24999 3.125ZM19.7917 15.625V3.125H23.9583V15.625H19.7917Z"
        fill="white"
      />
    </svg>
  ),
  roundStar: (
    <svg
      width="25"
      height="25"
      viewBox="0 0 25 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M2.08334 12.5002C2.08334 6.75016 6.73959 2.0835 12.4896 2.0835C18.25 2.0835 22.9167 6.75016 22.9167 12.5002C22.9167 18.2502 18.25 22.9168 12.4896 22.9168C6.73959 22.9168 2.08334 18.2502 2.08334 12.5002ZM12.5 16.0939L16.9063 18.7502L15.7396 13.7293L19.625 10.3647L14.5 9.92725L12.5 5.2085L10.5 9.93766L5.37501 10.3752L9.26042 13.7397L8.09376 18.7502L12.5 16.0939Z"
        fill="white"
      />
    </svg>
  ),
  megaphone: (
    <svg
      width="25"
      height="25"
      viewBox="0 0 25 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M19.9912 2.00195C19.8599 2.00188 19.7298 2.02769 19.6084 2.07792C19.4871 2.12815 19.3768 2.20181 19.2839 2.29468C19.1911 2.38755 19.1174 2.49782 19.0672 2.61918C19.017 2.74054 18.9911 2.87061 18.9912 3.00195V3.63867C18.1478 4.68438 17.0819 5.52887 15.871 6.11067C14.66 6.69248 13.3346 6.99696 11.9912 7.00195H5.99121C5.19583 7.00282 4.43327 7.31917 3.87085 7.88159C3.30843 8.44401 2.99208 9.20657 2.99121 10.002V12.002C2.99208 12.7973 3.30843 13.5599 3.87085 14.1223C4.43327 14.6847 5.19583 15.0011 5.99121 15.002H6.475L4.07227 20.6084C4.00698 20.7604 3.98047 20.9263 3.99512 21.0911C4.00978 21.256 4.06514 21.4146 4.15624 21.5528C4.24734 21.6909 4.37133 21.8043 4.51706 21.8827C4.6628 21.9611 4.82572 22.0021 4.99121 22.002H8.99121C9.18696 22.0021 9.37843 21.9446 9.54182 21.8368C9.7052 21.729 9.83329 21.5755 9.91016 21.3955L12.6339 15.04C13.8646 15.1303 15.0636 15.472 16.157 16.0439C17.2505 16.6158 18.215 17.4058 18.9912 18.365V19.002C18.9912 19.2672 19.0966 19.5215 19.2841 19.7091C19.4716 19.8966 19.726 20.002 19.9912 20.002C20.2564 20.002 20.5108 19.8966 20.6983 19.7091C20.8859 19.5215 20.9912 19.2672 20.9912 19.002V3.00195C20.9913 2.87061 20.9655 2.74054 20.9152 2.61918C20.865 2.49782 20.7914 2.38755 20.6985 2.29468C20.6056 2.2018 20.4953 2.12815 20.374 2.07792C20.2526 2.02769 20.1226 2.00188 19.9912 2.00195ZM5.99121 13.002C5.72605 13.0018 5.4718 12.8964 5.2843 12.7089C5.0968 12.5214 4.99139 12.2671 4.99121 12.002V10.002C4.99139 9.73679 5.09681 9.48254 5.2843 9.29505C5.4718 9.10755 5.72605 9.00213 5.99121 9.00195H6.99121V13.002H5.99121ZM8.33203 20.002H6.50781L8.65039 15.002H10.4746L8.33203 20.002ZM18.9912 15.5238C17.0195 13.8994 14.5459 13.0082 11.9912 13.0019H8.99121V9.0019H11.9912C14.5459 8.99537 17.0195 8.10406 18.9912 6.47956V15.5238Z"
        fill="white"
      />
    </svg>
  ),
  bag: (
    <svg
      width="25"
      height="25"
      viewBox="0 0 25 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M16.6667 6.25016H20.8333C21.9896 6.25016 22.9167 7.17725 22.9167 8.3335V19.7918C22.9167 20.9481 21.9896 21.8752 20.8333 21.8752H4.16667C3.01042 21.8752 2.08334 20.9481 2.08334 19.7918L2.09375 8.3335C2.09375 7.17725 3.01042 6.25016 4.16667 6.25016H8.33334V4.16683C8.33334 3.01058 9.26042 2.0835 10.4167 2.0835H14.5833C15.7396 2.0835 16.6667 3.01058 16.6667 4.16683V6.25016ZM10.4167 6.25016H14.5833V4.16683H10.4167V6.25016Z"
        fill="white"
      />
    </svg>
  ),
  complexArrow: (
    <svg
      width="25"
      height="25"
      viewBox="0 0 25 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M16.6667 6.25L19.0521 8.63542L13.9687 13.7188L9.80208 9.55208L2.08333 17.2812L3.55208 18.75L9.80208 12.5L13.9687 16.6667L20.5312 10.1146L22.9167 12.5V6.25H16.6667Z"
        fill="white"
      />
    </svg>
  ),
  arrows: (
    <svg
      width="25"
      height="25"
      viewBox="0 0 25 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M17.7188 5.2085L21.875 9.37516L17.7188 13.5418V10.4168H10.4167V8.3335H17.7188V5.2085ZM3.125 15.6252L7.28125 11.4585V14.5835H14.5833V16.6668H7.28125V19.7918L3.125 15.6252Z"
        fill="white"
      />
    </svg>
  ),
  buy: (
    <svg
      width="25"
      height="25"
      viewBox="0 0 25 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7.42229 19.8203C7.84429 19.8203 8.18729 20.1633 8.18729 20.5853C8.18729 21.0073 7.84429 21.3493 7.42229 21.3493C7.00029 21.3493 6.65829 21.0073 6.65829 20.5853C6.65829 20.1633 7.00029 19.8203 7.42229 19.8203Z"
        stroke="white"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M18.6747 19.8203C19.0967 19.8203 19.4397 20.1633 19.4397 20.5853C19.4397 21.0073 19.0967 21.3493 18.6747 21.3493C18.2527 21.3493 17.9097 21.0073 17.9097 20.5853C17.9097 20.1633 18.2527 19.8203 18.6747 19.8203Z"
        stroke="white"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M2.74991 3.25L4.82991 3.61L5.79291 15.083C5.87091 16.018 6.65191 16.736 7.58991 16.736H18.5019C19.3979 16.736 20.1579 16.078 20.2869 15.19L21.2359 8.632C21.3529 7.823 20.7259 7.099 19.9089 7.099H5.16391"
        stroke="white"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M14.1254 10.7949H16.8984"
        stroke="white"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  home: (
    <svg
      width="25"
      height="25"
      viewBox="0 0 25 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M9.15722 20.7714V17.7047C9.1572 16.9246 9.79312 16.2908 10.581 16.2856H13.4671C14.2587 16.2856 14.9005 16.9209 14.9005 17.7047V17.7047V20.7809C14.9003 21.4432 15.4343 21.9845 16.103 22H18.0271C19.9451 22 21.5 20.4607 21.5 18.5618V18.5618V9.83784C21.4898 9.09083 21.1355 8.38935 20.538 7.93303L13.9577 2.6853C12.8049 1.77157 11.1662 1.77157 10.0134 2.6853L3.46203 7.94256C2.86226 8.39702 2.50739 9.09967 2.5 9.84736V18.5618C2.5 20.4607 4.05488 22 5.97291 22H7.89696C8.58235 22 9.13797 21.4499 9.13797 20.7714V20.7714"
        stroke="white"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  dollar: (
    <svg
      width="25"
      height="25"
      viewBox="0 0 25 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12.2916 11.3542C9.927 10.7396 9.16659 10.1042 9.16659 9.11458C9.16659 7.97917 10.2187 7.1875 11.9791 7.1875C13.8333 7.1875 14.5208 8.07292 14.5833 9.375H16.8853C16.8124 7.58333 15.7187 5.9375 13.5416 5.40625V3.125H10.4166V5.375C8.39575 5.8125 6.77075 7.125 6.77075 9.13542C6.77075 11.5417 8.76034 12.7396 11.6666 13.4375C14.2708 14.0625 14.7916 14.9792 14.7916 15.9479C14.7916 16.6667 14.2812 17.8125 11.9791 17.8125C9.83325 17.8125 8.9895 16.8542 8.87492 15.625H6.58325C6.70825 17.9062 8.41659 19.1875 10.4166 19.6146V21.875H13.5416V19.6354C15.5728 19.25 17.1874 18.0729 17.1874 15.9375C17.1874 12.9792 14.6562 11.9688 12.2916 11.3542Z"
        fill="white"
      />
    </svg>
  ),
  graph: (
    <svg
      width="25"
      height="25"
      viewBox="0 0 25 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M11.6 5H14.4V19H11.6V5ZM6 9.2H9V19H6V9.2ZM20 13H17.2V19H20V13Z"
        fill="white"
      />
    </svg>
  ),
  product: (
    <svg
      width="25"
      height="25"
      viewBox="0 0 25 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M22.9167 9.375H17.9272L13.3542 2.53125C12.9376 1.91667 12.0313 1.91667 11.6251 2.53125L7.05216 9.375H2.08341C1.5105 9.375 1.04175 9.84375 1.04175 10.4167C1.04175 10.5104 1.05216 10.6042 1.08341 10.6979L3.72925 20.3542C3.96883 21.2292 4.77091 21.875 5.72925 21.875H19.2709C20.2292 21.875 21.0313 21.2292 21.2813 20.3542L23.9272 10.6979L23.9584 10.4167C23.9584 9.84375 23.4897 9.375 22.9167 9.375ZM12.4897 4.98959L15.4167 9.37501H9.56258L12.4897 4.98959ZM10.4167 15.625C10.4167 16.7708 11.3542 17.7083 12.5001 17.7083C13.6459 17.7083 14.5834 16.7708 14.5834 15.625C14.5834 14.4792 13.6459 13.5417 12.5001 13.5417C11.3542 13.5417 10.4167 14.4792 10.4167 15.625Z"
        fill="white"
      />
    </svg>
  ),
  crossed: (
    <svg
      width="25"
      height="25"
      viewBox="0 0 25 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8.36655 15.1601L15.1601 8.36655C14.7936 7.74622 14.5833 7.02264 14.5833 6.24992C14.5833 3.94873 16.4487 2.08325 18.7499 2.08325C21.0511 2.08325 22.9166 3.94873 22.9166 6.24992C22.9166 8.55111 21.0511 10.4166 18.7499 10.4166C17.9772 10.4166 17.2536 10.2062 16.6333 9.83969L9.83969 16.6333C10.2062 17.2536 10.4166 17.9772 10.4166 18.7499C10.4166 21.0511 8.55111 22.9166 6.24992 22.9166C3.94873 22.9166 2.08325 21.0511 2.08325 18.7499C2.08325 16.4487 3.94873 14.5833 6.24992 14.5833C7.02264 14.5833 7.74622 14.7936 8.36655 15.1601ZM6.24992 20.8333C7.40051 20.8333 8.33325 19.9005 8.33325 18.7499C8.33325 17.5993 7.40051 16.6666 6.24992 16.6666C5.09933 16.6666 4.16659 17.5993 4.16659 18.7499C4.16659 19.9005 5.09933 20.8333 6.24992 20.8333ZM20.8333 6.24992C20.8333 7.40051 19.9005 8.33325 18.7499 8.33325C17.5993 8.33325 16.6666 7.40051 16.6666 6.24992C16.6666 5.09933 17.5993 4.16659 18.7499 4.16659C19.9005 4.16659 20.8333 5.09933 20.8333 6.24992Z"
        fill="white"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M15.1601 16.6334L8.36655 9.83985C7.74622 10.2064 7.02264 10.4167 6.24992 10.4167C3.94873 10.4167 2.08325 8.55127 2.08325 6.25008C2.08325 3.94889 3.94873 2.08341 6.24992 2.08341C8.55111 2.08341 10.4166 3.94889 10.4166 6.25008C10.4166 7.0228 10.2062 7.74639 9.83969 8.36671L16.6333 15.1603C17.2536 14.7938 17.9772 14.5834 18.7499 14.5834C21.0511 14.5834 22.9166 16.4489 22.9166 18.7501C22.9166 21.0513 21.0511 22.9167 18.7499 22.9167C16.4487 22.9167 14.5833 21.0513 14.5833 18.7501C14.5833 17.9774 14.7936 17.2538 15.1601 16.6334ZM20.8333 18.7501C20.8333 17.5995 19.9005 16.6667 18.7499 16.6667C17.5993 16.6667 16.6666 17.5995 16.6666 18.7501C16.6666 19.9007 17.5993 20.8334 18.7499 20.8334C19.9005 20.8334 20.8333 19.9007 20.8333 18.7501ZM6.24992 4.16675C7.40051 4.16675 8.33325 5.09949 8.33325 6.25008C8.33325 7.40067 7.40051 8.33341 6.24992 8.33341C5.09933 8.33341 4.16659 7.40067 4.16659 6.25008C4.16659 5.09949 5.09933 4.16675 6.24992 4.16675Z"
        fill="white"
      />
    </svg>
  ),
  happyFace: (
    <svg
      width="25"
      height="25"
      viewBox="0 0 25 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M13 2C7.486 2 3 6.486 3 12C3 17.514 7.486 22 13 22C18.514 22 23 17.514 23 12C23 6.486 18.514 2 13 2ZM13 20C8.589 20 5 16.411 5 12C5 7.589 8.589 4 13 4C17.411 4 21 7.589 21 12C21 16.411 17.411 20 13 20Z"
        fill="white"
      />
      <path
        d="M9.5 12C10.3284 12 11 11.3284 11 10.5C11 9.67157 10.3284 9 9.5 9C8.67157 9 8 9.67157 8 10.5C8 11.3284 8.67157 12 9.5 12Z"
        fill="white"
      />
      <path
        d="M16.493 11.986C17.3176 11.986 17.986 11.3176 17.986 10.493C17.986 9.66844 17.3176 9 16.493 9C15.6684 9 15 9.66844 15 10.493C15 11.3176 15.6684 11.986 16.493 11.986Z"
        fill="white"
      />
      <path d="M13 18C17 18 18 14 18 14H8C8 14 9 18 13 18Z" fill="white" />
    </svg>
  ),
  path: (
    <svg
      width="25"
      height="25"
      viewBox="0 0 25 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M23.9584 8.33333C23.9584 9.47917 23.0209 10.4167 21.8751 10.4167C21.6876 10.4167 21.5105 10.3958 21.3438 10.3438L17.6355 14.0417C17.6876 14.2083 17.7084 14.3958 17.7084 14.5833C17.7084 15.7292 16.7709 16.6667 15.6251 16.6667C14.4792 16.6667 13.5417 15.7292 13.5417 14.5833C13.5417 14.3958 13.5626 14.2083 13.6147 14.0417L10.9584 11.3854C10.7917 11.4375 10.6042 11.4583 10.4167 11.4583C10.2292 11.4583 10.0417 11.4375 9.87508 11.3854L5.1355 16.1354C5.18758 16.3021 5.20841 16.4792 5.20841 16.6667C5.20841 17.8125 4.27091 18.75 3.12508 18.75C1.97925 18.75 1.04175 17.8125 1.04175 16.6667C1.04175 15.5208 1.97925 14.5833 3.12508 14.5833C3.31258 14.5833 3.48966 14.6042 3.65633 14.6562L8.40633 9.91667C8.35425 9.75 8.33341 9.5625 8.33341 9.375C8.33341 8.22917 9.27091 7.29167 10.4167 7.29167C11.5626 7.29167 12.5001 8.22917 12.5001 9.375C12.5001 9.5625 12.4792 9.75 12.4272 9.91667L15.0834 12.5729C15.2501 12.5208 15.4376 12.5 15.6251 12.5C15.8126 12.5 16.0001 12.5208 16.1667 12.5729L19.8647 8.86458C19.8126 8.69792 19.7917 8.52083 19.7917 8.33333C19.7917 7.1875 20.7292 6.25 21.8751 6.25C23.0209 6.25 23.9584 7.1875 23.9584 8.33333Z"
        fill="white"
      />
    </svg>
  ),
  question: (
    <svg
      width="12"
      height="18"
      viewBox="0 0 12 18"
      fill="inherit"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M5.664 11.544C5.248 11.544 4.92 11.408 4.68 11.136C4.456 10.864 4.344 10.48 4.344 9.984C4.344 9.232 4.488 8.608 4.776 8.112C5.064 7.6 5.464 7.08 5.976 6.552C6.344 6.152 6.616 5.808 6.792 5.52C6.984 5.232 7.08 4.912 7.08 4.56C7.08 4.208 6.952 3.928 6.696 3.72C6.44 3.512 6.088 3.408 5.64 3.408C5.272 3.408 4.904 3.48 4.536 3.624C4.184 3.752 3.784 3.944 3.336 4.2L2.76 4.488C2.216 4.792 1.776 4.944 1.44 4.944C1.04 4.944 0.696 4.776 0.408 4.44C0.136 4.088 0 3.664 0 3.168C0 2.832 0.056 2.552 0.168 2.328C0.296 2.104 0.496 1.888 0.768 1.68C1.488 1.152 2.304 0.744 3.216 0.456C4.144 0.152 5.072 0 6 0C7.04 0 7.968 0.184 8.784 0.552C9.6 0.904 10.24 1.4 10.704 2.04C11.168 2.664 11.4 3.376 11.4 4.176C11.4 4.768 11.272 5.312 11.016 5.808C10.776 6.304 10.48 6.728 10.128 7.08C9.776 7.432 9.32 7.856 8.76 8.352C8.232 8.784 7.824 9.16 7.536 9.48C7.264 9.784 7.088 10.104 7.008 10.44C6.944 10.792 6.784 11.064 6.528 11.256C6.288 11.448 6 11.544 5.664 11.544ZM5.712 17.28C5.056 17.28 4.504 17.056 4.056 16.608C3.624 16.16 3.408 15.608 3.408 14.952C3.408 14.296 3.624 13.744 4.056 13.296C4.504 12.848 5.056 12.624 5.712 12.624C6.384 12.624 6.936 12.848 7.368 13.296C7.816 13.744 8.04 14.296 8.04 14.952C8.04 15.608 7.816 16.16 7.368 16.608C6.936 17.056 6.384 17.28 5.712 17.28Z"
        fill="inherit"
        stroke="inherit"
      />
    </svg>
  ),
  ok: (
    <svg
      width="25"
      height="25"
      viewBox="0 0 25 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M3 14.3889L9.08696 21L23 4"
        stroke="white"
        strokeWidth="3"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  x: (
    <svg
      width="15"
      height="15"
      viewBox="0 0 15 15"
      fill="inherit"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M15 1.51071L13.4893 0L7.5 5.98929L1.51071 0L0 1.51071L5.98929 7.5L0 13.4893L1.51071 15L7.5 9.01071L13.4893 15L15 13.4893L9.01071 7.5L15 1.51071Z"
        fill="inherit"
        stroke="inherit"
      />
    </svg>
  ),
  bigCard: (
    <svg
      width="25"
      height="25"
      viewBox="0 0 25 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M2 4.16699C0.895431 4.16699 0 5.06242 0 6.16699V18.8337C0 19.9382 0.89543 20.8337 2 20.8337H23C24.1046 20.8337 25 19.9382 25 18.8337V6.16699C25 5.06242 24.1046 4.16699 23 4.16699H2ZM2.66667 5.83366C2.11438 5.83366 1.66667 6.28137 1.66667 6.83366V18.167C1.66667 18.7193 2.11438 19.167 2.66667 19.167H22.3333C22.8856 19.167 23.3333 18.7193 23.3333 18.167V6.83366C23.3333 6.28137 22.8856 5.83366 22.3333 5.83366H2.66667Z"
        fill="white"
      />
      <path d="M13.3333 8.33398H20" stroke="white" strokeLinecap="round" />
      <path d="M13.3333 10H18.3333" stroke="white" strokeLinecap="round" />
      <path d="M13.3333 11.667H20" stroke="white" strokeLinecap="round" />
      <path d="M13.3333 13.334H16.6667" stroke="white" strokeLinecap="round" />
      <rect x="3.33334" y="7.5" width="7.5" height="7.5" rx="1" fill="white" />
    </svg>
  ),
  picture: (
    <svg
      width="25"
      height="25"
      viewBox="0 0 25 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M20 4C21.1 4 22 4.9 22 6V20C22 21.1 21.1 22 20 22H6C4.9 22 4 21.1 4 20V6C4 4.9 4.9 4 6 4H20ZM12 17.51L9.5 14.5L6 19H20L15.5 13L12 17.51Z"
        fill="white"
      />
    </svg>
  ),
  cropperIcon: (
    <svg
      width="60"
      height="60"
      viewBox="0 0 60 60"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M45 30C43.625 30 42.5 31.125 42.5 32.5V37.5H37.5C36.125 37.5 35 38.625 35 40C35 41.375 36.125 42.5 37.5 42.5H45C46.375 42.5 47.5 41.375 47.5 40V32.5C47.5 31.125 46.375 30 45 30ZM17.5 22.5H22.5C23.875 22.5 25 21.375 25 20C25 18.625 23.875 17.5 22.5 17.5H15C13.625 17.5 12.5 18.625 12.5 20V27.5C12.5 28.875 13.625 30 15 30C16.375 30 17.5 28.875 17.5 27.5V22.5ZM52.5 7.5H7.5C4.75 7.5 2.5 9.75 2.5 12.5V47.5C2.5 50.25 4.75 52.5 7.5 52.5H52.5C55.25 52.5 57.5 50.25 57.5 47.5V12.5C57.5 9.75 55.25 7.5 52.5 7.5ZM50 47.525H10C8.625 47.525 7.5 46.4 7.5 45.025V14.975C7.5 13.6 8.625 12.475 10 12.475H50C51.375 12.475 52.5 13.6 52.5 14.975V45.025C52.5 46.4 51.375 47.525 50 47.525Z"
        fill="white"
      />
    </svg>
  ),
  eye: (
    <svg
      width="25"
      height="25"
      viewBox="0 0 25 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M13 10C11.358 10 10 11.359 10 13C10 14.642 11.358 16 13 16C14.641 16 16 14.642 16 13C16 11.359 14.641 10 13 10Z"
        fill="white"
      />
      <path
        d="M13 6C5.408 6 3.12632 12.617 3.10543 12.684L3 13L3.10444 13.316C3.12632 13.383 5.408 20 13 20C20.592 20 22.8737 13.383 22.8946 13.316L23 13L22.8956 12.684C22.8737 12.617 20.592 6 13 6ZM13 18C7.67774 18 5.61587 14.154 5.11657 13C5.61786 11.842 7.68072 8 13 8C18.3223 8 20.3841 11.846 20.8834 13C20.3821 14.158 18.3193 18 13 18Z"
        fill="white"
      />
    </svg>
  ),
  eyeUnhidden: (
    <svg
      width="25"
      height="25"
      viewBox="0 0 25 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8.43366 12.5C8.43366 14.7222 10.2528 16.5303 12.4987 16.5303C14.7345 16.5303 16.5536 14.7222 16.5536 12.5C16.5536 10.2677 14.7345 8.45959 12.4987 8.45959C10.2528 8.45959 8.43366 10.2677 8.43366 12.5ZM18.4743 6.29798C20.2528 7.67171 21.767 9.68181 22.8544 12.197C22.9357 12.3889 22.9357 12.6111 22.8544 12.7929C20.6796 17.8232 16.8076 20.8333 12.4987 20.8333H12.4885C8.18976 20.8333 4.3178 17.8232 2.14301 12.7929C2.06171 12.6111 2.06171 12.3889 2.14301 12.197C4.3178 7.16666 8.18976 4.16666 12.4885 4.16666H12.4987C14.6532 4.16666 16.6959 4.91414 18.4743 6.29798ZM12.4999 15.0129C13.8922 15.0129 15.0304 13.8816 15.0304 12.4978C15.0304 11.1038 13.8922 9.97252 12.4999 9.97252C12.378 9.97252 12.256 9.98262 12.1442 10.0028C12.1036 11.1139 11.189 12.0028 10.0609 12.0028H10.0101C9.97961 12.1644 9.95928 12.3261 9.95928 12.4978C9.95928 13.8816 11.0975 15.0129 12.4999 15.0129Z"
        fill="white"
      />
    </svg>
  ),
  eyeHidden: (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g id="Iconly/Bold/Hide">
        <g id="Hide">
          <path
            id="Hide_2"
            fillRule="evenodd"
            clipRule="evenodd"
            d="M9.80327 15.2526C10.4277 15.6759 11.1888 15.9319 11.9987 15.9319C14.1453 15.9319 15.8919 14.1696 15.8919 12.0037C15.8919 11.1866 15.6382 10.4186 15.2186 9.78855L14.1551 10.8617C14.3307 11.1964 14.4283 11.5902 14.4283 12.0037C14.4283 13.3525 13.3354 14.4551 11.9987 14.4551C11.5889 14.4551 11.1986 14.3567 10.8668 14.1795L9.80327 15.2526ZM18.4288 6.54952C19.8436 7.84907 21.0438 9.60149 21.9415 11.7083C22.0195 11.8954 22.0195 12.112 21.9415 12.2892C19.8534 17.1921 16.1358 20.1259 11.9987 20.1259H11.9889C10.1058 20.1259 8.30063 19.5056 6.71018 18.3735L4.81725 20.2834C4.67089 20.4311 4.4855 20.5 4.30011 20.5C4.11472 20.5 3.91957 20.4311 3.78297 20.2834C3.53903 20.0373 3.5 19.6435 3.69515 19.358L3.72442 19.3186L18.1556 4.75771C18.1751 4.73802 18.1946 4.71833 18.2044 4.69864L18.2044 4.69863C18.2239 4.67894 18.2434 4.65925 18.2532 4.63957L19.1704 3.71413C19.4631 3.42862 19.9217 3.42862 20.2046 3.71413C20.4974 3.99964 20.4974 4.4722 20.2046 4.75771L18.4288 6.54952ZM8.09836 12.0075C8.09836 12.2635 8.12764 12.5195 8.16667 12.7558L4.55643 16.3984C3.5807 15.2564 2.7318 13.8781 2.05854 12.293C1.98049 12.1158 1.98049 11.8992 2.05854 11.7122C4.14662 6.80933 7.86419 3.88534 11.9916 3.88534H12.0013C13.3966 3.88534 14.7529 4.22007 16.0018 4.85015L12.7429 8.13841C12.5087 8.09903 12.255 8.0695 12.0013 8.0695C9.84494 8.0695 8.09836 9.83177 8.09836 12.0075Z"
            fill="#0984FF"
          />
        </g>
      </g>
    </svg>
  ),
  shareLink: (
    <svg
      width="25"
      height="25"
      viewBox="0 0 25 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6 7V5H20V7H6ZM10 15H6L13 8L20 15H16V21H10V15Z"
        fill="white"
      />
    </svg>
  ),
  balloon: (
    <svg
      width="25"
      height="25"
      viewBox="0 0 25 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M19.5544 7.9387C19.5544 4.68185 16.3834 2 12.5001 2C8.61673 2 5.44571 4.67756 5.44571 7.9387C5.44571 10.4704 7.38094 14.049 10.2044 15.3921L9.41915 17.2244C9.10161 18.1212 9.87828 18.4301 10.2216 18.4301H11.6719C12.0881 19.5629 12.3585 20.9146 12.3585 22.1204C12.3585 22.6052 12.7532 23 13.2381 23C13.723 23 14.1178 22.6052 14.1178 22.1204C14.1178 20.8631 13.9204 19.623 13.5342 18.4301H14.7743C15.3364 18.4301 15.9243 17.868 15.5767 17.2244L14.7914 15.3921C17.6192 14.0362 19.5544 10.4318 19.5544 7.9387ZM11.5646 16.7309L11.9122 15.8942C12.1053 15.9156 12.8991 15.9156 13.0922 15.8942L13.4398 16.7352H11.5646V16.7309ZM12.5001 14.1864C9.59937 14.1864 7.18784 10.3459 7.18784 7.9387C7.18784 5.61729 9.55217 3.74213 12.5001 3.74213C15.448 3.74213 17.8123 5.61729 17.8123 7.9387C17.8123 10.3502 15.4008 14.1864 12.5001 14.1864Z"
        fill="white"
      />
    </svg>
  ),
  plan: (
    <svg
      width="27"
      height="27"
      viewBox="0 0 27 27"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M11.1213 25.6176C12.4705 25.6176 13.5874 24.6156 13.7745 23.3172H17.8638L17.368 23.8129L17.9102 24.3551L19.0604 23.2049C19.1353 23.13 19.1727 23.0319 19.1727 22.9338C19.1727 22.8357 19.1353 22.7376 19.0604 22.6627L17.9102 21.5125L17.368 22.0547L17.8638 22.5504H13.7745C13.5874 21.252 12.4705 20.25 11.1213 20.25C9.64161 20.25 8.4375 21.4539 8.4375 22.9338C8.4375 24.4137 9.64161 25.6176 11.1213 25.6176ZM11.1213 21.0168C12.1783 21.0168 13.0383 21.8768 13.0383 22.9338C13.0383 23.9908 12.1783 24.8508 11.1213 24.8508C10.0643 24.8508 9.2043 23.9908 9.2043 22.9338C9.2043 21.8768 10.0643 21.0168 11.1213 21.0168Z"
        fill="white"
        stroke="white"
        strokeWidth="0.5"
      />
      <path
        d="M22.9338 25.6176C24.4135 25.6176 25.6176 24.4137 25.6176 22.9338C25.6176 21.4539 24.4135 20.25 22.9338 20.25C21.4541 20.25 20.25 21.4539 20.25 22.9338C20.25 24.4137 21.4541 25.6176 22.9338 25.6176ZM22.9338 21.0168C23.9908 21.0168 24.8508 21.8768 24.8508 22.9338C24.8508 23.9908 23.9908 24.8508 22.9338 24.8508C21.8768 24.8508 21.0168 23.9908 21.0168 22.9338C21.0168 21.8768 21.8768 21.0168 22.9338 21.0168Z"
        fill="white"
        stroke="white"
        strokeWidth="0.5"
      />
      <path
        d="M8.89515 10.5469C7.54595 10.5469 6.42903 11.5489 6.24198 12.8473H5.63625C2.99363 12.8473 0.84375 14.9972 0.84375 17.6398C0.84375 20.2824 2.99363 22.4323 5.63625 22.4323H6.436L5.94027 22.928L6.48242 23.4701L7.63263 22.32C7.70751 22.2451 7.74495 22.147 7.74495 22.0489C7.74495 21.9508 7.70751 21.8527 7.63263 21.7778L6.48242 20.6276L5.94027 21.1698L6.436 21.6655H5.63625C3.41635 21.6655 1.61055 19.8595 1.61055 17.6398C1.61055 15.4201 3.41635 13.6141 5.63625 13.6141H6.24198C6.42903 14.9125 7.54595 15.9145 8.89515 15.9145C10.3748 15.9145 11.5789 14.7105 11.5789 13.2307C11.5789 11.7508 10.3748 10.5469 8.89515 10.5469ZM8.89515 15.1477C7.83818 15.1477 6.97815 14.2876 6.97815 13.2307C6.97815 12.1737 7.83818 11.3137 8.89515 11.3137C9.95212 11.3137 10.8122 12.1737 10.8122 13.2307C10.8122 14.2876 9.95212 15.1477 8.89515 15.1477Z"
        fill="white"
        stroke="white"
        strokeWidth="0.5"
      />
      <path
        d="M10.3164 2.10627L9.77427 2.64843L10.27 3.14415H8.22537H6.18074C5.9937 1.84573 4.87675 0.84375 3.52755 0.84375C2.04786 0.84375 0.84375 2.04768 0.84375 3.52755C0.84375 5.00742 2.04786 6.21135 3.52755 6.21135C4.87675 6.21135 5.9937 5.20937 6.18074 3.91095H10.27L9.77427 4.40667L10.3164 4.94883L11.4666 3.79863C11.5415 3.72374 11.5789 3.62565 11.5789 3.52755C11.5789 3.42945 11.5415 3.33136 11.4666 3.25647L10.3164 2.10627ZM3.52755 5.44455C2.47058 5.44455 1.61055 4.58452 1.61055 3.52755C1.61055 2.47058 2.47058 1.61055 3.52755 1.61055C4.58452 1.61055 5.44455 2.47058 5.44455 3.52755C5.44455 4.58452 4.58452 5.44455 3.52755 5.44455Z"
        fill="white"
        stroke="white"
        strokeWidth="0.5"
      />
      <path
        d="M25.0763 8.02406C25.0763 5.34888 22.8999 3.1725 20.2247 3.1725H18.059C17.8697 1.85808 16.739 0.84375 15.3731 0.84375C13.8752 0.84375 12.6562 2.06252 12.6562 3.56062C12.6562 5.05873 13.8752 6.2775 15.3731 6.2775C16.739 6.2775 17.8697 5.26317 18.059 3.94875H20.2247C22.4719 3.94875 24.3 5.77699 24.3 8.02406C24.3 10.2711 22.4719 12.0994 20.2247 12.0994H13.9813L14.4832 11.5975L13.9343 11.0487L12.77 12.2131C12.6942 12.2889 12.6562 12.3882 12.6562 12.4875C12.6562 12.5868 12.6942 12.6861 12.77 12.7619L13.9343 13.9263L14.4832 13.3775L13.9813 12.8756H20.2247C22.8999 12.8756 25.0763 10.6992 25.0763 8.02406ZM15.3731 5.50125C14.3031 5.50125 13.4325 4.63062 13.4325 3.56062C13.4325 2.49063 14.3031 1.62 15.3731 1.62C16.4431 1.62 17.3138 2.49063 17.3138 3.56062C17.3138 4.63062 16.4431 5.50125 15.3731 5.50125Z"
        fill="white"
        stroke="white"
        strokeWidth="0.5"
      />
    </svg>
  ),
  clip: (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M16.5 6V17.5C16.5 19.71 14.71 21.5 12.5 21.5C10.29 21.5 8.5 19.71 8.5 17.5V5C8.5 3.62 9.62 2.5 11 2.5C12.38 2.5 13.5 3.62 13.5 5V15.5C13.5 16.05 13.05 16.5 12.5 16.5C11.95 16.5 11.5 16.05 11.5 15.5V6H10V15.5C10 16.88 11.12 18 12.5 18C13.88 18 15 16.88 15 15.5V5C15 2.79 13.21 1 11 1C8.79 1 7 2.79 7 5V17.5C7 20.54 9.46 23 12.5 23C15.54 23 18 20.54 18 17.5V6H16.5Z"
        fill="white"
      />
    </svg>
  ),
  userCheck: (
    <svg
      width="25"
      height="25"
      viewBox="0 0 25 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M13 8C13 10.2091 11.2091 12 9 12C6.79086 12 5 10.2091 5 8C5 5.79086 6.79086 4 9 4C11.2091 4 13 5.79086 13 8ZM11 8C11 9.10457 10.1046 10 9 10C7.89543 10 7 9.10457 7 8C7 6.89543 7.89543 6 9 6C10.1046 6 11 6.89543 11 8Z"
        fill="white"
      />
      <path
        d="M16.994 12.584L21.294 8.29199L22.706 9.70799L16.994 15.41L14.288 12.706L15.702 11.292L16.994 12.584Z"
        fill="white"
      />
      <path
        d="M13 19H15C15 15.6863 12.3137 13 9 13C5.68629 13 3 15.6863 3 19H5C5 16.7909 6.79086 15 9 15C11.2091 15 13 16.7909 13 19Z"
        fill="white"
      />
    </svg>
  ),
  heart: (
    <svg
      width="25"
      height="25"
      viewBox="0 0 25 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M13 6.09C14.09 4.81 15.76 4 17.5 4C20.58 4 23 6.42 23 9.5C23 13.2769 19.6056 16.3549 14.4627 21.0185L14.45 21.03L13 22.35L11.55 21.04L11.5105 21.0041C6.38263 16.3442 3 13.2703 3 9.5C3 6.42 5.42 4 8.5 4C10.24 4 11.91 4.81 13 6.09ZM13 19.65L13.1 19.55C17.86 15.24 21 12.39 21 9.5C21 7.5 19.5 6 17.5 6C15.96 6 14.46 6.99 13.94 8.36H12.07C11.54 6.99 10.04 6 8.5 6C6.5 6 5 7.5 5 9.5C5 12.39 8.14 15.24 12.9 19.55L13 19.65Z"
        fill="white"
      />
    </svg>
  ),
  cloud: (
    <svg
      width="25"
      height="25"
      viewBox="0 0 25 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7.29608 9.89768L6.34774 10.0526C4.44924 10.3628 3 12.0141 3 14C3 16.2091 4.79086 18 7 18H20C21.6569 18 23 16.6569 23 15C23 13.5005 21.898 12.2548 20.4601 12.0348L19.1442 11.8334L18.822 10.5418C18.1711 7.93171 15.8087 6 13 6C10.7575 6 8.79944 7.22938 7.76775 9.06051L7.29608 9.89768ZM20.7626 10.0578C19.8948 6.57805 16.7485 4 13 4C10.0065 4 7.39696 5.64419 6.02529 8.07877C3.17514 8.54439 1 11.0182 1 14C1 17.3137 3.68629 20 7 20H20C22.7614 20 25 17.7614 25 15C25 12.4979 23.1621 10.425 20.7626 10.0578Z"
        fill="white"
      />
    </svg>
  ),
  copy: (
    <svg
      width="26"
      height="25"
      viewBox="0 0 26 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M17.0263 3H6.28947C5.30526 3 4.5 3.81818 4.5 4.81818V17.5455H6.28947V4.81818H17.0263V3ZM19.7105 6.63636H9.86842C8.88421 6.63636 8.07895 7.45455 8.07895 8.45455V21.1818C8.07895 22.1818 8.88421 23 9.86842 23H19.7105C20.6947 23 21.5 22.1818 21.5 21.1818V8.45455C21.5 7.45455 20.6947 6.63636 19.7105 6.63636ZM19.7105 21.1818H9.86841V8.45455H19.7105V21.1818Z"
        fill="white"
      />
    </svg>
  ),
  sun: (
    <svg
      width="25"
      height="25"
      viewBox="0 0 25 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M7.993 12C7.993 14.761 10.239 17.007 13 17.007C15.761 17.007 18.007 14.761 18.007 12C18.007 9.239 15.761 6.993 13 6.993C10.239 6.993 7.993 9.239 7.993 12ZM13 8.993C14.658 8.993 16.007 10.342 16.007 12C16.007 13.658 14.658 15.007 13 15.007C11.342 15.007 9.993 13.658 9.993 12C9.993 10.342 11.342 8.993 13 8.993ZM11.998 19H13.998V22H11.998V19ZM11.998 2H13.998V5H11.998V2ZM2.998 11H5.998V13H2.998V11ZM19.998 11H22.998V13H19.998V11Z"
        fill="white"
      />
      <path
        d="M5.21905 18.3634L7.33974 16.2414L8.75437 17.6552L6.63368 19.7772L5.21905 18.3634Z"
        fill="white"
      />
      <path
        d="M17.2402 6.34358L19.3622 4.22152L20.7765 5.63571L18.6545 7.75777L17.2402 6.34358Z"
        fill="white"
      />
      <path
        d="M7.34174 7.75858L5.22105 5.63663L6.63568 4.22284L8.75637 6.34479L7.34174 7.75858Z"
        fill="white"
      />
      <path
        d="M20.7758 18.3635L19.3616 19.7778L17.2395 17.6558L18.6537 16.2415L20.7758 18.3635Z"
        fill="white"
      />
    </svg>
  ),
  arrowRight: (
    <svg
      width="25"
      height="25"
      viewBox="0 0 25 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M23 13L19 9V12H4V14H19V17L23 13Z" fill="white" />
    </svg>
  ),
  arrowRightBig: (
    <svg
      width="24"
      height="22"
      viewBox="0 0 24 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M23.6164 9.97254L14.9491 0.42225C14.7017 0.149636 14.372 0 14.0204 0C13.6684 0 13.3388 0.149851 13.0914 0.42225L12.3045 1.28954C12.0573 1.56172 11.9211 1.92528 11.9211 2.31292C11.9211 2.70034 12.0573 3.07615 12.3045 3.34833L17.3608 8.93196H1.29657C0.572288 8.93196 0 9.55674 0 10.355V11.5811C0 12.3794 0.572288 13.0672 1.29657 13.0672H17.4182L12.3047 18.682C12.0575 18.9546 11.9213 19.3083 11.9213 19.6959C11.9213 20.0831 12.0575 20.4419 12.3047 20.7143L13.0916 21.5788C13.339 21.8514 13.6686 22 14.0206 22C14.3722 22 14.7019 21.8495 14.9493 21.5769L23.6166 12.0268C23.8646 11.7533 24.001 11.3883 24 11.0002C24.0008 10.6109 23.8646 10.2456 23.6164 9.97254Z"
        fill="white"
      />
    </svg>
  ),
  shield: (
    <svg
      width="25"
      height="25"
      viewBox="0 0 25 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M4 6L13 2L22 6V12C22 17.55 18.16 22.74 13 24C7.84 22.74 4 17.55 4 12V6ZM7 14L11 18L19 10L17.59 8.58L11 15.17L8.41 12.59L7 14Z"
        fill="white"
      />
    </svg>
  ),
  supervisor: (
    <svg
      width="25"
      height="25"
      viewBox="0 0 25 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12.99 9C12.99 10.66 11.66 12 10 12C8.34 12 7 10.66 7 9C7 7.34 8.34 6 10 6C11.66 6 12.99 7.34 12.99 9ZM19.99 10.5C19.99 11.88 18.88 13 17.5 13C16.12 13 15 11.88 15 10.5C15 9.12 16.12 8 17.5 8C18.88 8 19.99 9.12 19.99 10.5ZM17.5 15C15.67 15 12 15.92 12 17.75V20H23V17.75C23 15.92 19.33 15 17.5 15ZM3 17.5C3 15.17 7.67 14 10 14C10.66 14 11.5 14.1 12.37 14.28C10.33 15.41 10 16.9 10 17.75V20H3V17.5Z"
        fill="white"
      />
    </svg>
  ),
  cartPlus: (
    <svg
      width="25"
      height="25"
      viewBox="0 0 25 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M14 10H12V7H9V5H12V2H14V5H17V7H14V10ZM6.01 21C6.01 19.9 6.9 19 8 19C9.1 19 10 19.9 10 21C10 22.1 9.1 23 8 23C6.9 23 6.01 22.1 6.01 21ZM18 19C16.9 19 16.01 19.9 16.01 21C16.01 22.1 16.9 23 18 23C19.1 23 20 22.1 20 21C20 19.9 19.1 19 18 19ZM16.55 14H9.1L8 16H20V18H8C6.48 18 5.52 16.37 6.25 15.03L7.6 12.59L4 5H2V3H5.27L9.53 12H16.55L20.41 5L22.16 5.96L18.3 12.97C17.96 13.59 17.3 14 16.55 14Z"
        fill="white"
      />
    </svg>
  ),
  goal: (
    <svg
      width="17"
      height="17"
      viewBox="0 0 17 17"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M0 8.5C0 13.1946 3.80563 17 8.49961 17C13.1944 17 17 13.1946 17 8.5C17 3.80563 13.1944 0 8.49961 0C3.80563 0 0 3.80563 0 8.5ZM9.19196 11.564H7.80785V15.384C4.5397 15.0594 1.94087 12.4602 1.61629 9.19187H5.43615V7.80775H1.61629C1.94107 4.5394 4.5397 1.94038 7.80785 1.616V5.43606H9.19196V1.616C12.4609 1.94058 15.0597 4.5396 15.3843 7.80775H11.5641V9.19187H15.3843C15.0597 12.4602 12.4611 15.0592 9.19196 15.384V11.564Z"
        fill="white"
      />
    </svg>
  ),
  okSmall: (
    <svg
      width="16"
      height="14"
      viewBox="0 0 16 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M2 8.11111L5.65217 12L14 2"
        stroke="inherit"
        strokeWidth="3"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  CSCanvas: (
    <svg
      width="74"
      height="48"
      viewBox="0 0 74 48"
      fill="inherit"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect width="14" height="31" fill="#DDE2E5" />
      <rect x="30" width="14" height="31" fill="#DDE2E5" />
      <rect x="60" width="14" height="31" fill="inherit" className="CSCanvas" />
      <rect x="15" width="14" height="15" fill="#DDE2E5" />
      <rect x="45" width="14" height="15" fill="#DDE2E5" />
      <rect x="15" y="16" width="14" height="15" fill="#DDE2E5" />
      <rect x="45" y="16" width="14" height="15" fill="#DDE2E5" />
      <rect y="32" width="24" height="16" fill="#DDE2E5" />
      <rect x="50" y="32" width="24" height="16" fill="#DDE2E5" />
      <rect x="25" y="32" width="24" height="16" fill="#DDE2E5" />
    </svg>
  ),
  VPCanvas: (
    <svg
      width="74"
      height="48"
      viewBox="0 0 74 48"
      fill="inherit"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect width="14" height="31" fill="#DDE2E5" />
      <rect
        x="30"
        width="14"
        height="31"
        fill="#inherit"
        className="VPCanvas"
      />
      <rect x="60" width="14" height="31" fill="#DDE2E5" />
      <rect x="15" width="14" height="15" fill="#DDE2E5" />
      <rect x="45" width="14" height="15" fill="#DDE2E5" />
      <rect x="15" y="16" width="14" height="15" fill="#DDE2E5" />
      <rect x="45" y="16" width="14" height="15" fill="#DDE2E5" />
      <rect y="32" width="24" height="16" fill="#DDE2E5" />
      <rect x="50" y="32" width="24" height="16" fill="#DDE2E5" />
      <rect x="25" y="32" width="24" height="16" fill="#DDE2E5" />
    </svg>
  ),
  CRCanvas: (
    <svg
      width="74"
      height="48"
      viewBox="0 0 74 48"
      fill="inherit"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect width="14" height="31" fill="#DDE2E5" />
      <rect x="30" width="14" height="31" fill="#DDE2E5" />
      <rect x="60" width="14" height="31" fill="#DDE2E5" />
      <rect x="15" width="14" height="15" fill="#DDE2E5" />
      <rect
        x="45"
        width="14"
        height="15"
        fill="#inherit"
        className="CRCanvas"
      />
      <rect x="15" y="16" width="14" height="15" fill="#DDE2E5" />
      <rect x="45" y="16" width="14" height="15" fill="#DDE2E5" />
      <rect y="32" width="24" height="16" fill="#DDE2E5" />
      <rect x="50" y="32" width="24" height="16" fill="#DDE2E5" />
      <rect x="25" y="32" width="24" height="16" fill="#DDE2E5" />
    </svg>
  ),
  ChannelsCanvas: (
    <svg
      width="74"
      height="48"
      viewBox="0 0 74 48"
      fill="inherit"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect width="14" height="31" fill="#DDE2E5" />
      <rect x="30" width="14" height="31" fill="#DDE2E5" />
      <rect x="60" width="14" height="31" fill="#DDE2E5" />
      <rect x="15" width="14" height="15" fill="#DDE2E5" />
      <rect x="45" width="14" height="15" fill="#DDE2E5" />
      <rect x="15" y="16" width="14" height="15" fill="#DDE2E5" />
      <rect
        x="45"
        y="16"
        width="14"
        height="15"
        fill="#inherit"
        className="ChannelsCanvas"
      />
      <rect y="32" width="24" height="16" fill="#DDE2E5" />
      <rect x="50" y="32" width="24" height="16" fill="#DDE2E5" />
      <rect x="25" y="32" width="24" height="16" fill="#DDE2E5" />
    </svg>
  ),
  KeyThingCanvas: (
    <svg
      width="74"
      height="48"
      viewBox="0 0 74 48"
      fill="inherit"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect width="14" height="31" fill="#inherit" className="KeyThingCanvas" />
      <rect x="30" width="14" height="31" fill="#DDE2E5" />
      <rect x="60" width="14" height="31" fill="#DDE2E5" />
      <rect
        x="15"
        width="14"
        height="15"
        fill="#inherit"
        className="KeyThingCanvas"
      />
      <rect x="45" width="14" height="15" fill="#DDE2E5" />
      <rect
        x="15"
        y="16"
        width="14"
        height="15"
        fill="#inherit"
        className="KeyThingCanvas"
      />
      <rect x="45" y="16" width="14" height="15" fill="#DDE2E5" />
      <rect y="32" width="24" height="16" fill="#DDE2E5" />
      <rect x="50" y="32" width="24" height="16" fill="#DDE2E5" />
      <rect x="25" y="32" width="24" height="16" fill="#DDE2E5" />
    </svg>
  ),
  FinanceCanvas: (
    <svg
      width="74"
      height="48"
      viewBox="0 0 74 48"
      fill="inherit"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect width="14" height="31" fill="#DDE2E5" />
      <rect x="30" width="14" height="31" fill="#DDE2E5" />
      <rect x="60" width="14" height="31" fill="#DDE2E5" />
      <rect x="15" width="14" height="15" fill="#DDE2E5" />
      <rect x="45" width="14" height="15" fill="#DDE2E5" />
      <rect x="15" y="16" width="14" height="15" fill="#DDE2E5" />
      <rect x="45" y="16" width="14" height="15" fill="#DDE2E5" />
      <rect
        y="32"
        width="24"
        height="16"
        fill="#inherit"
        className="FinanceCanvas"
      />
      <rect
        x="50"
        y="32"
        width="24"
        height="16"
        fill="#inherit"
        className="FinanceCanvas"
      />
      <rect x="25" y="32" width="24" height="16" fill="#DDE2E5" />
    </svg>
  ),
  SustainabilityCanvas: (
    <svg
      width="74"
      height="48"
      viewBox="0 0 74 48"
      fill="inherit"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect width="14" height="31" fill="#DDE2E5" />
      <rect x="30" width="14" height="31" fill="#DDE2E5" />
      <rect x="60" width="14" height="31" fill="#DDE2E5" />
      <rect x="15" width="14" height="15" fill="#DDE2E5" />
      <rect x="45" width="14" height="15" fill="#DDE2E5" />
      <rect x="15" y="16" width="14" height="15" fill="#DDE2E5" />
      <rect x="45" y="16" width="14" height="15" fill="#DDE2E5" />
      <rect y="32" width="24" height="16" fill="#DDE2E5" />
      <rect x="50" y="32" width="24" height="16" fill="#DDE2E5" />
      <rect
        x="25"
        y="32"
        width="24"
        height="16"
        fill="#inherit"
        className="SustainabilityCanvas"
      />
    </svg>
  ),
  analysisIcon: (
    <svg
      width="45"
      height="45"
      viewBox="0 0 45 45"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect
        x="1"
        y="1"
        width="43"
        height="43"
        rx="7"
        stroke="#0984FF"
        strokeOpacity="0.1"
        strokeWidth="2"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M16.2 33H12V18.3H16.2V33ZM24.6 33H20.4V12H24.6V33ZM33 33H28.8V24.6H33V33Z"
        fill="#0984FF"
      />
    </svg>
  ),
  rowExpandIcon: (
    <svg
      width="25"
      height="25"
      viewBox="0 0 25 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5.9975 8L12.5 13.5628L19.0025 8L21 9.71255L12.5 17L4 9.71255L5.9975 8Z"
        fill="#334249"
      />
    </svg>
  ),
  rowExpandIconClose: (
    <svg
      width="25"
      height="25"
      viewBox="0 0 25 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M19.0025 17L12.5 11.4372L5.9975 17L4 15.2874L12.5 8L21 15.2874L19.0025 17Z"
        fill="#334249"
      />
    </svg>
  ),
  rowSettingIcon: (
    <svg
      width="45"
      height="45"
      viewBox="0 0 45 45"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect
        x="1"
        y="1"
        width="43"
        height="43"
        rx="7"
        stroke="#0984FF"
        strokeOpacity="0.1"
        strokeWidth="2"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M30.5227 23.529C30.5659 23.193 30.5983 22.857 30.5983 22.5C30.5983 22.143 30.5659 21.807 30.5227 21.471L32.8004 19.7385C33.0055 19.581 33.0595 19.2975 32.9299 19.0665L30.771 15.4335C30.6415 15.2025 30.35 15.1185 30.1125 15.2025L27.4247 16.2525C26.8634 15.8325 26.2589 15.486 25.6004 15.2235L25.1902 12.441C25.1578 12.189 24.9312 12 24.6613 12H20.3435C20.0736 12 19.8469 12.189 19.8145 12.441L19.4043 15.2235C18.7459 15.486 18.1414 15.843 17.5801 16.2525L14.8922 15.2025C14.6439 15.108 14.3633 15.2025 14.2338 15.4335L12.0748 19.0665C11.9345 19.2975 11.9993 19.581 12.2044 19.7385L14.482 21.471C14.4388 21.807 14.4065 22.1535 14.4065 22.5C14.4065 22.8465 14.4388 23.193 14.482 23.529L12.2044 25.2615C11.9993 25.419 11.9453 25.7025 12.0748 25.9335L14.2338 29.5665C14.3633 29.7975 14.6547 29.8815 14.8922 29.7975L17.5801 28.7475C18.1414 29.1675 18.7459 29.514 19.4043 29.7765L19.8145 32.559C19.8469 32.811 20.0736 33 20.3435 33H24.6613C24.9312 33 25.1578 32.811 25.1902 32.559L25.6004 29.7765C26.2589 29.514 26.8634 29.157 27.4247 28.7475L30.1125 29.7975C30.3608 29.892 30.6415 29.7975 30.771 29.5665L32.9299 25.9335C33.0595 25.7025 33.0055 25.419 32.8004 25.2615L30.5227 23.529ZM22.5024 26.175C20.419 26.175 18.7243 24.5265 18.7243 22.5C18.7243 20.4735 20.419 18.825 22.5024 18.825C24.5857 18.825 26.2805 20.4735 26.2805 22.5C26.2805 24.5265 24.5857 26.175 22.5024 26.175Z"
        fill="#0984FF"
      />
    </svg>
  ),
  settingIcon: (
    <svg
      width="25"
      height="25"
      viewBox="0 0 25 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M20.5227 13.529C20.5659 13.193 20.5983 12.857 20.5983 12.5C20.5983 12.143 20.5659 11.807 20.5227 11.471L22.8004 9.7385C23.0055 9.581 23.0595 9.2975 22.9299 9.0665L20.771 5.4335C20.6415 5.2025 20.35 5.1185 20.1125 5.2025L17.4247 6.2525C16.8634 5.8325 16.2589 5.486 15.6004 5.2235L15.1902 2.441C15.1578 2.189 14.9312 2 14.6613 2H10.3435C10.0736 2 9.84692 2.189 9.81454 2.441L9.40435 5.2235C8.74588 5.486 8.14138 5.843 7.58007 6.2525L4.89222 5.2025C4.64395 5.108 4.36329 5.2025 4.23375 5.4335L2.07484 9.0665C1.93451 9.2975 1.99928 9.581 2.20438 9.7385L4.48203 11.471C4.43885 11.807 4.40646 12.1535 4.40646 12.5C4.40646 12.8465 4.43885 13.193 4.48203 13.529L2.20438 15.2615C1.99928 15.419 1.94531 15.7025 2.07484 15.9335L4.23375 19.5665C4.36329 19.7975 4.65474 19.8815 4.89222 19.7975L7.58007 18.7475C8.14138 19.1675 8.74588 19.514 9.40435 19.7765L9.81454 22.559C9.84692 22.811 10.0736 23 10.3435 23H14.6613C14.9312 23 15.1578 22.811 15.1902 22.559L15.6004 19.7765C16.2589 19.514 16.8634 19.157 17.4247 18.7475L20.1125 19.7975C20.3608 19.892 20.6415 19.7975 20.771 19.5665L22.9299 15.9335C23.0595 15.7025 23.0055 15.419 22.8004 15.2615L20.5227 13.529ZM12.5024 16.175C10.419 16.175 8.72427 14.5265 8.72427 12.5C8.72427 10.4735 10.419 8.825 12.5024 8.825C14.5857 8.825 16.2805 10.4735 16.2805 12.5C16.2805 14.5265 14.5857 16.175 12.5024 16.175Z"
        fill="#0984FF"
      />
    </svg>
  ),
  searchIcon: (
    <svg
      width="25"
      height="25"
      viewBox="0 0 25 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M15.3819 14.6918H16.1498L21 19.5517L19.5517 21L14.6918 16.1498V15.3819L14.4294 15.1098C13.3213 16.0623 11.8828 16.6358 10.3179 16.6358C6.82847 16.6358 4 13.8073 4 10.3179C4 6.82847 6.82847 4 10.3179 4C13.8073 4 16.6358 6.82847 16.6358 10.3179C16.6358 11.8828 16.0623 13.3213 15.1098 14.4294L15.3819 14.6918ZM5.94397 10.3179C5.94397 12.7381 7.89766 14.6918 10.3179 14.6918C12.7381 14.6918 14.6918 12.7381 14.6918 10.3179C14.6918 7.89766 12.7381 5.94397 10.3179 5.94397C7.89766 5.94397 5.94397 7.89766 5.94397 10.3179Z"
        fill="#ACB5BD"
      />
    </svg>
  ),
  closeIcon: (
    <svg
      width="15"
      height="15"
      viewBox="0 0 15 15"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M15 1.51071L13.4893 0L7.5 5.98929L1.51071 0L0 1.51071L5.98929 7.5L0 13.4893L1.51071 15L7.5 9.01071L13.4893 15L15 13.4893L9.01071 7.5L15 1.51071Z"
        fill="#334249"
      />
    </svg>
  ),
  expandIcon: (
    <svg
      width="12"
      height="12"
      viewBox="0 0 12 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6.35355 8.35355L8.85355 5.85355C9.04882 5.65829 9.04882 5.34171 8.85355 5.14645C8.65829 4.95118 8.34171 4.95118 8.14645 5.14645L6 7.29289L3.85355 5.14645C3.65829 4.95118 3.34171 4.95118 3.14645 5.14645C2.95118 5.34171 2.95118 5.65829 3.14645 5.85355L5.64645 8.35355C5.84171 8.54882 6.15829 8.54882 6.35355 8.35355Z"
        fill="#334249"
      />
    </svg>
  ),
  expandIconLarge: (
    <svg
      width="17"
      height="9"
      viewBox="0 0 17 9"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M1.9975 0L8.5 5.56275L15.0025 0L17 1.71255L8.5 9L0 1.71255L1.9975 0Z"
        fill="#334249"
      />
    </svg>
  ),
  prevIcon: (
    <svg
      width="25"
      height="25"
      viewBox="0 0 25 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M17 5.9975L11.4372 12.5L17 19.0025L15.2874 21L8 12.5L15.2874 4L17 5.9975Z"
        fill="#ACB5BD"
        className="prev-project-icon"
      />
    </svg>
  ),
  nextIcon: (
    <svg
      width="25"
      height="25"
      viewBox="0 0 25 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8 19.0025L13.5628 12.5L8 5.9975L9.71255 4L17 12.5L9.71255 21L8 19.0025Z"
        fill="#ACB5BD"
        className="next-project-icon"
      />
    </svg>
  ),
  checkedIcon: (
    <svg
      width="16"
      height="14"
      viewBox="0 0 16 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M2 8.11111L5.65217 12L14 2"
        stroke="white"
        strokeWidth="3"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  dashIcon: (
    <svg
      width="7"
      height="3"
      viewBox="0 0 7 3"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M1.824 2.512C1.51467 2.512 1.28 2.44267 1.12 2.304C0.970667 2.16533 0.896 1.97333 0.896 1.728C0.896 1.48267 0.970667 1.29067 1.12 1.152C1.28 1.00267 1.51467 0.928 1.824 0.928H5.12C5.42933 0.928 5.65867 1.00267 5.808 1.152C5.968 1.29067 6.048 1.48267 6.048 1.728C6.048 1.97333 5.968 2.16533 5.808 2.304C5.65867 2.44267 5.42933 2.512 5.12 2.512H1.824Z"
        fill="#ACB5BD"
      />
    </svg>
  ),
  questionIcon: (
    <svg
      width="9"
      height="13"
      viewBox="0 0 9 13"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M4.504 8.736C4.32267 8.736 4.17333 8.672 4.056 8.544C3.94933 8.416 3.896 8.24 3.896 8.016C3.896 7.42933 4.00267 6.93333 4.216 6.528C4.42933 6.12267 4.73867 5.68 5.144 5.2C5.464 4.816 5.69867 4.496 5.848 4.24C5.99733 3.984 6.072 3.696 6.072 3.376C6.072 3.024 5.93867 2.74667 5.672 2.544C5.416 2.33067 5.064 2.224 4.616 2.224C4.232 2.224 3.864 2.30933 3.512 2.48C3.16 2.64 2.74933 2.87467 2.28 3.184C2.01333 3.33333 1.79467 3.408 1.624 3.408C1.44267 3.408 1.28267 3.328 1.144 3.168C1.016 2.99733 0.952 2.8 0.952 2.576C0.952 2.26667 1.08 2.016 1.336 1.824C1.784 1.44 2.312 1.14133 2.92 0.927999C3.528 0.703999 4.14133 0.591999 4.76 0.591999C5.41067 0.591999 5.98667 0.703999 6.488 0.927999C7 1.152 7.39467 1.46133 7.672 1.856C7.96 2.25067 8.104 2.704 8.104 3.216C8.104 3.77067 7.97067 4.256 7.704 4.672C7.43733 5.07733 7.048 5.536 6.536 6.048C6.09867 6.496 5.768 6.87467 5.544 7.184C5.33067 7.48267 5.19733 7.824 5.144 8.208C5.112 8.37867 5.03733 8.512 4.92 8.608C4.81333 8.69333 4.67467 8.736 4.504 8.736ZM4.536 12.096C4.19467 12.096 3.912 11.984 3.688 11.76C3.464 11.5253 3.352 11.2373 3.352 10.896C3.352 10.5547 3.464 10.272 3.688 10.048C3.912 9.81333 4.19467 9.696 4.536 9.696C4.87733 9.696 5.16 9.81333 5.384 10.048C5.608 10.272 5.72 10.5547 5.72 10.896C5.72 11.2373 5.60267 11.5253 5.368 11.76C5.144 11.984 4.86667 12.096 4.536 12.096Z"
        fill="#FF6D00"
      />
    </svg>
  ),
  eksIcon: (
    <svg
      width="15"
      height="15"
      viewBox="0 0 15 15"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M15 1.51071L13.4893 0L7.5 5.98929L1.51071 0L0 1.51071L5.98929 7.5L0 13.4893L1.51071 15L7.5 9.01071L13.4893 15L15 13.4893L9.01071 7.5L15 1.51071Z"
        fill="#FF463A"
      />
    </svg>
  ),
  addIcon: (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fill="#fff"
        d="M16 0.667c8.468 0 15.333 6.865 15.333 15.333s-6.865 15.333-15.333 15.333c-8.468 0-15.333-6.865-15.333-15.333s6.865-15.333 15.333-15.333z"
      />
      <path
        fill="#acb5bd"
        d="M16 20c-0.169 0-0.297-0.048-0.383-0.144-0.079-0.095-0.127-0.219-0.127-0.354 0-0.010 0-0.019 0.001-0.029l-0 0.001v-3.028h-2.983c-0.008 0-0.017 0.001-0.026 0.001-0.136 0-0.26-0.049-0.356-0.129l0.001 0.001c-0.085-0.085-0.128-0.207-0.128-0.367s0.043-0.281 0.128-0.367c0.095-0.079 0.219-0.127 0.354-0.127 0.010 0 0.019 0 0.029 0.001l-0.001-0h2.981v-2.933c0-0.169 0.041-0.297 0.127-0.381 0.085-0.096 0.213-0.144 0.383-0.144s0.297 0.048 0.383 0.144c0.085 0.084 0.127 0.212 0.127 0.381v2.933h2.981c0.16 0 0.28 0.043 0.365 0.127 0.096 0.085 0.144 0.208 0.144 0.367 0 0.16-0.048 0.281-0.144 0.367-0.084 0.085-0.207 0.128-0.365 0.128h-2.981v3.027c0 0.16-0.041 0.288-0.127 0.383-0.085 0.096-0.213 0.144-0.383 0.144z"
      />
      <path
        fill="none"
        stroke="#acb5bd"
        d="M16 0.667c8.468 0 15.333 6.865 15.333 15.333s-6.865 15.333-15.333 15.333c-8.468 0-15.333-6.865-15.333-15.333s6.865-15.333 15.333-15.333z"
      />
    </svg>
  ),
  funFirst: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="164"
      height="162"
      viewBox="0 0 164 162"
      fill="inherit"
    >
      <path
        d="M-1.9984 71.5809C-1.99841 97.1889 -1.74557 123.042 -1.99841 148.65C-2.05459 153.413 -0.484085 155.334 4.09509 156.763C34.8571 166.429 63.6765 162.781 90.7582 145.27C96.5173 141.544 102.465 139.007 109.039 137.157C114.629 135.588 119.95 133.314 125.288 131.073C137.2 126.086 148.153 119.872 151.693 106.059C152.873 101.408 155.256 97.0492 157.11 92.5383C161.324 82.3679 164.526 72.0832 163.88 60.7641C163.262 50.0895 163.122 38.9606 163.88 28.3139C164.863 14.3051 159.602 1.82319 155.079 -10.8968C154.039 -13.8106 152.839 -13.601 150.339 -13.601C101.57 -13.5449 52.8647 -13.4609 4.0951 -13.601C-1.74836 -15.3528 -2.02649 -11.0151 -1.9984 -6.84051C-1.91412 19.2438 -1.9984 45.4965 -1.9984 71.5809Z"
        fill="inherit"
      />
    </svg>
  ),
  funSecond: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="296"
      height="506"
      viewBox="0 0 296 506"
      fill="inherit"
    >
      <path
        d="M316.26 19.878C349.322 63.4571 385.855 160.102 377.322 243.056C370.581 308.123 355.087 366.678 321.54 413.071C309.696 429.509 301.802 458.092 291.681 468.914C287.743 473.189 282.207 477.605 276.681 481.577C189.49 543.358 81.2725 479.635 38.772 345.804C12.4678 262.977 -6.63714 172.885 2.66277 121.32C11.3995 73.0254 68.9302 26.8046 106.723 -14.2154C138.773 -49.045 189.884 -70.7788 221.605 -61.8008C248.135 -54.3445 296.231 -6.45935 316.26 19.878Z"
        fill="inherit"
      />
    </svg>
  ),
  funSummaryThird: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="128"
      height="379"
      viewBox="0 0 128 379"
      fill="inherit"
    >
      <path
        d="M76.7203 57.3755C103.086 69.9398 107.919 97.0546 118.534 120.068C125.179 134.532 128.027 149.903 127.423 166.137C126.733 184.789 127.725 203.485 127.466 222.137C126.819 266.479 110.896 305.381 83.754 339.75C72.3189 354.257 63.6023 370.275 54.7131 386.207C49.9233 394.886 44.0978 397.088 31.5839 395.49C-3.10983 391 -38.2782 391.302 -73.0151 395.361C-88.4634 397.174 -92.0449 394.972 -92.0449 384.135C-91.8292 259.873 -91.8292 135.654 -92.0449 11.3925C-92.0449 3.70709 -90.5778 1.24603 -82.1632 0.943817C-46.7791 -0.394653 -16.3573 12.4719 12.1658 31.6423C23.1262 39.0255 76.7203 57.3755 76.7203 57.3755Z"
        fill="inherit"
      />
    </svg>
  ),
  funSummaryFourth: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="194"
      height="377"
      viewBox="0 0 194 377"
      fill="inherit"
    >
      <path
        d="M333.67 356.42C295.859 377.566 218.759 387.966 160.347 358.413C114.54 335.187 75.2508 305.46 48.0442 260.828C38.3959 245.055 19.1861 229.628 13.2754 216.975C10.9285 212.035 8.92932 206.315 7.10396 199.902C-21.0588 98.9363 45.4365 8.97741 150.351 1.6975C215.282 -2.80911 283.95 1.9575 319.502 24.2306C352.793 45.117 375.305 112.889 397.818 160.296C416.941 200.508 422.852 256.148 410.335 284.834C399.904 308.84 356.53 343.593 333.67 356.42Z"
        fill="#inherit"
      />
    </svg>
  ),
  funTeamFifth: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="682"
      height="788"
      viewBox="0 0 682 788"
      fill="inherit"
    >
      <path
        d="M161.239 824.224C77.5388 792.489 62.1961 724.003 28.4969 665.877C7.40076 629.343 -1.6405 590.52 0.277344 549.515C2.46918 502.403 -0.681519 455.183 0.140381 408.071C2.19519 296.072 52.7438 197.813 138.909 111.006C175.211 74.3631 202.883 33.9037 231.103 -6.33752C246.308 -28.2575 264.802 -33.8193 304.528 -29.7843C414.667 -18.4426 526.313 -19.206 636.588 -29.4572C685.63 -34.0375 697 -28.4757 697 -1.10289C696.315 312.757 696.315 626.508 697 940.368C697 959.779 692.342 965.996 665.63 966.759C553.299 970.14 456.722 937.641 366.173 889.221C331.378 870.573 161.239 824.224 161.239 824.224Z"
        fill="inherit"
      />
    </svg>
  ),
  iconKP: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="26"
      height="26"
      viewBox="0 0 26 26"
      fill="inherit"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M21.9891 10.794C22.2497 10.3044 18.8377 10.6607 16.6119 9.93695C15.3841 9.53766 12.6611 8.5456 11.8657 8.91896L6.71498 11.3365C5.75719 11.7861 6.77819 14.9063 8.32471 16.9169C8.89088 17.6529 16.1689 15.6896 17.1947 15.2081C18.2245 14.7248 16.4598 12.4618 16.673 12.2651C16.8861 12.0686 20.8751 12.8859 21.9891 10.794ZM13.5158 8.15264C13.2367 7.78457 11.9337 6.62048 9.83277 7.62079L6.09029 9.40266C3.98915 10.403 4.75175 11.8244 5.03086 12.1925C5.30988 12.5605 5.04846 11.4223 6.35061 10.8023L11.2702 8.46003C12.6353 7.81006 13.7949 8.52061 13.5158 8.15264Z"
        fill="inherit"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M21.7333 15.8942C21.9797 15.5748 19.0988 14.4955 17.7149 13.0477C16.9516 12.249 15.1928 12.3433 14.2196 12.2876L12.9788 12.2698C11.807 12.2028 10.6583 11.2179 10.4781 13.3254C10.4122 14.097 11.2123 14.9606 12.4674 15.0324C13.7273 15.1045 16.0928 14.2921 16.4268 14.2365C16.7605 14.1808 20.3806 17.6473 21.7333 15.8942Z"
        fill="inherit"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M20.435 17.3444C20.6814 17.025 17.8005 15.9457 16.4166 14.4979C15.6532 13.6992 13.8944 13.7935 12.9213 13.7378L11.6805 13.72C10.5087 13.6529 9.35996 12.668 9.17979 14.7756C9.11383 15.5472 9.91397 16.4108 11.1691 16.4826C12.4289 16.5547 14.5188 15.996 14.8528 15.9404C15.1865 15.8848 19.0823 19.0975 20.435 17.3444Z"
        fill="inherit"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M18.468 18.6607C18.7144 18.3413 15.8335 17.2621 14.4496 15.8142C13.6862 15.0155 11.9274 15.1098 10.9543 15.0541L9.71346 15.0363C9.5333 17.1439 7.94698 17.7272 9.20206 17.7989C10.4619 17.871 12.4056 17.5961 12.7396 17.5405C13.2108 17.0037 17.1153 20.4138 18.468 18.6607Z"
        fill="inherit"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M16.8182 20.3692C17.0646 20.0498 13.8946 19.2893 12.7998 17.5227C12.2808 16.6852 10.2777 16.8183 9.30449 16.7626L11.0453 17.6949C9.87349 17.6279 9.51726 15.793 9.33709 17.9005C9.27113 18.6721 8.70655 18.7173 9.96163 18.7891C11.2215 18.8612 10.7559 19.3046 11.0898 19.249C11.4236 19.1933 15.4655 22.1223 16.8182 20.3692Z"
        fill="inherit"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M4.14843 14.4796C4.78377 14.4796 5.29881 14.0739 5.29881 13.5733C5.29881 13.0728 4.78377 12.667 4.14843 12.667C3.51309 12.667 2.99805 13.0728 2.99805 13.5733C2.99805 14.0739 3.51309 14.4796 4.14843 14.4796Z"
        fill="inherit"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6.84814 17.1994C7.48348 17.1994 7.99852 16.7936 7.99852 16.293C7.99852 15.7925 7.48348 15.3867 6.84814 15.3867C6.2128 15.3867 5.69775 15.7925 5.69775 16.293C5.69775 16.7936 6.2128 17.1994 6.84814 17.1994Z"
        fill="inherit"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8.19775 18.5588C8.83309 18.5588 9.34813 18.153 9.34813 17.6524C9.34813 17.1519 8.83309 16.7461 8.19775 16.7461C7.56241 16.7461 7.04736 17.1519 7.04736 17.6524C7.04736 18.153 7.56241 18.5588 8.19775 18.5588Z"
        fill="inherit"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6.44424 16.0045C7.11106 15.7323 7.31768 15.0681 6.90575 14.5208C6.49381 13.9736 5.61931 13.7506 4.95249 14.0228C4.28568 14.295 4.07906 14.9593 4.49099 15.5065C4.90292 16.0537 5.77742 16.2767 6.44424 16.0045Z"
        fill="inherit"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M14.0966 9.13523C19.0152 10.2626 12.3014 8.69523 13.7663 8.70436C14.5743 8.7094 16.3475 8.66691 16.9831 8.98833L21.0989 11.0696C21.8642 11.4566 21.6869 12.856 20.9366 13.6086C20.6619 13.8841 15.104 11.6746 14.2842 11.26C13.4614 10.8439 14.3231 10.0009 14.1356 9.8661C13.9482 9.73141 11.9324 8.63918 14.0966 9.13523ZM15.7544 8.6245C16.0142 8.36296 17.1836 7.5552 18.844 8.39783L21.8016 9.89879C23.4621 10.7415 22.7197 11.766 22.4599 12.0275C22.2002 12.289 22.5057 11.4525 21.4766 10.9303L17.5887 8.95721C16.5099 8.4097 15.4946 8.88596 15.7544 8.6245Z"
        fill="inherit"
      />
    </svg>
  ),
  iconKA: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="26"
      height="26"
      viewBox="0 0 26 26"
      fill="inherit"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M4.99805 12.5039C4.99805 17.1985 8.80367 21.0039 13.4977 21.0039C18.1924 21.0039 21.998 17.1985 21.998 12.5039C21.998 7.80953 18.1924 4.00391 13.4977 4.00391C8.80367 4.00391 4.99805 7.80953 4.99805 12.5039ZM14.19 15.5679H12.8059V19.3879C9.53773 19.0633 6.9389 16.4641 6.61432 13.1958H10.4342V11.8117H6.61432C6.9391 8.54331 9.53773 5.94428 12.8059 5.6199V9.43996H14.19V5.6199C17.4589 5.94448 20.0578 8.5435 20.3823 11.8117H16.5621V13.1958H20.3823C20.0578 16.4641 17.4591 19.0631 14.19 19.3879V15.5679Z"
        fill="inherit"
      />
    </svg>
  ),
  iconKR: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="25"
      height="25"
      viewBox="0 0 25 25"
      fill="inherit"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5.95459 13.1326V14.4113L10.1776 15.9228V14.644L5.95459 13.1326ZM5.95459 9.20975V10.4885L10.1776 11.9998V10.721L5.95459 9.20975ZM20.552 4.06753L12.4998 6.94955L4.44713 4.06753C4.12182 3.95118 3.75365 3.98669 3.46338 4.16235C3.17353 4.33802 3 4.63079 3 4.94453V17.0332C3 17.4195 3.26262 17.7667 3.66309 17.9102L12.0896 20.9258C12.0896 20.9258 12.2623 20.9756 12.295 20.9815C12.3626 20.9932 12.4312 21 12.5 21C12.5684 21 12.6368 20.9934 12.705 20.9815C12.7371 20.9756 12.9108 20.9254 12.9108 20.9254L21.3365 17.9102C21.7372 17.7667 22 17.4195 22 17.0332V4.94453C21.9998 4.63079 21.8258 4.33802 21.5358 4.16235C21.2459 3.98669 20.8773 3.95118 20.552 4.06753ZM4.68933 16.6498V6.06463L11.4447 8.48274V19.0673L4.68933 16.6498ZM13.555 19.0673V8.48274L20.3104 6.06463V16.6498L13.555 19.0673ZM14.822 14.644V15.9228L19.0449 14.4113V13.1326L14.822 14.644ZM14.822 10.721V11.9998L19.0449 10.4885V9.20975L14.822 10.721Z"
        fill="inherit"
      />
    </svg>
  ),
  iconVP: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="26"
      height="26"
      viewBox="0 0 26 26"
      fill="inherit"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M13.499 23.0023C14.8497 23.0307 15.9593 22.668 16.917 22.1319V19.9586H10.0809V22.1319C11.0388 22.668 12.1481 23.0305 13.499 23.0023ZM21.9756 8.10474C21.7103 5.22946 19.4576 2.00391 13.4978 2.00391C7.53859 2.00391 5.28605 5.22946 5.02058 8.10474C4.59941 12.6617 10.2227 14.1237 10.2227 18.6987H16.7729C16.7729 14.1237 22.3962 12.6617 21.9756 8.10474ZM13.4963 4.15762C17.0011 4.15762 19.149 5.54129 19.4006 8.27021C19.5386 9.76434 18.5445 10.7604 17.2032 12.392C16.2147 13.5957 15.0466 15.0164 14.5011 16.8654H12.4917C11.9462 15.0164 10.7786 13.5959 9.78958 12.392C8.4486 10.7604 7.45422 9.76434 7.59242 8.27021C7.8443 5.54108 9.99142 4.15762 13.4963 4.15762Z"
        fill="inherit"
      />
    </svg>
  ),
  iconGetKeepGrow: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="26"
      height="26"
      viewBox="0 0 26 26"
      fill="inherit"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M22.828 2.03943C22.4874 2.15472 22.3076 2.51655 22.4262 2.84772C23.4322 5.65144 21.4352 7.74431 19.9138 8.86571L19.2976 8.01059C19.0915 7.72478 18.6287 7.48664 18.2697 7.48138L14.8185 7.4965C14.4597 7.49104 13.9249 7.65086 13.6306 7.8512L3.46242 14.769C2.97001 15.1042 2.85013 15.7636 3.19488 16.2424L7.81644 22.6554C8.16141 23.1342 8.71573 23.0769 9.20814 22.7419L19.3764 15.8243C19.6706 15.6237 20.0075 15.1901 20.1258 14.8604L21.2064 11.5569C21.3241 11.227 21.2524 10.7234 21.0461 10.4374L20.6705 9.91634C22.716 8.39867 24.8384 5.7136 23.6602 2.42982C23.5412 2.09865 23.1684 1.92414 22.828 2.03943ZM16.5035 11.8379C15.9516 11.0718 16.143 10.0167 16.9316 9.48019C17.557 9.05451 18.3694 9.08559 18.9541 9.49867C18.6597 9.67087 18.4578 9.76999 18.4193 9.78763C18.0933 9.93715 17.954 10.3151 18.1073 10.6318C18.2189 10.8618 18.4538 10.9964 18.6991 10.9964C18.7923 10.9964 18.887 10.9766 18.9771 10.9355C19.1867 10.8395 19.4122 10.7236 19.6474 10.5886C19.7537 11.2114 19.4979 11.8673 18.9296 12.2537C18.1415 12.7896 17.0552 12.6033 16.5035 11.8379Z"
        fill="inherit"
      />
    </svg>
  ),
  iconChanel: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="26"
      height="26"
      viewBox="0 0 26 26"
      fill="inherit"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8.32214 3.50391V2.00391H5.32214V3.50391V6.87936H3.99805V11.379H9.64706V6.87936H8.32214V3.50391ZM17.3496 6.87936H18.6746V3.50403V2.00403H21.6746V3.50403V6.87936H22.9986V11.379H17.3496V6.87936ZM9.64706 13.6288H3.99805V16.859C3.99805 16.859 4.26047 17.5423 5.32305 17.9062V21.5032V23.0032H8.32305V21.5032V17.9168C9.42097 17.5556 9.64706 16.859 9.64706 16.859V13.6288ZM16.3228 16.859C16.3228 16.859 16.0967 17.5556 14.9988 17.9168V21.5032V23.0032H11.9988V21.5032V17.9062C10.9363 17.5423 10.6738 16.859 10.6738 16.859V13.6288H16.3228V16.859ZM21.6746 17.9168C22.7725 17.5556 22.9986 16.859 22.9986 16.859V13.6288H17.3496V16.859C17.3496 16.859 17.612 17.5423 18.6746 17.9062V21.5032V23.0032H21.6746V21.5032V17.9168ZM14.997 3.50391V2.00391H11.997V3.50391V6.87936H10.6738V11.379H16.3228V6.87936H14.997V3.50391Z"
        fill="inherit"
      />
    </svg>
  ),
  iconCustomerSegment: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="26"
      height="26"
      viewBox="0 0 26 26"
      fill="inherit"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M23.7119 17.4872C23.3468 16.8554 22.4965 16.4212 20.918 15.7492C19.3447 15.0789 18.8417 14.5137 18.8417 13.3033C18.8417 12.5762 19.322 12.814 19.5333 11.4836C19.6207 10.9314 20.045 11.4743 20.1263 10.2144C20.1263 9.7121 19.8946 9.58695 19.8946 9.58695C19.8946 9.58695 20.0123 8.84407 20.0582 8.27194C20.1154 7.5591 19.7056 5.71821 17.522 5.71821C15.338 5.71821 14.9286 7.55932 14.9859 8.27194C15.0319 8.84407 15.1492 9.58695 15.1492 9.58695C15.1492 9.58695 14.918 9.7121 14.918 10.2144C14.9992 11.4743 15.4231 10.9314 15.5109 11.4836C15.7218 12.814 16.2025 12.5764 16.2025 13.3033C16.2025 14.1262 15.9687 14.651 15.3249 15.1135C18.7622 16.8666 19.223 17.2239 19.223 18.7912V22.0039H23.9991C23.9991 22.0037 23.9573 17.9112 23.7119 17.4872ZM11.084 13.1065C11.084 12.1386 11.7255 12.4547 12.0072 10.6823C12.1238 9.94732 12.6905 10.6702 12.7989 8.99192C12.7989 8.32303 12.4898 8.15679 12.4898 8.15679C12.4898 8.15679 12.647 7.16727 12.7084 6.40533C12.7846 5.4562 12.2379 3.00391 9.32212 3.00391C6.4066 3.00391 5.8594 5.45598 5.9363 6.40533C5.99769 7.16727 6.15445 8.15679 6.15445 8.15679C6.15445 8.15679 5.84538 8.32303 5.84538 8.99192C5.95414 10.6702 6.52046 9.94732 6.63751 10.6823C6.91918 12.4544 7.5607 12.1384 7.5607 13.1065C7.5607 14.7183 6.88902 15.4711 4.78836 16.3637C4.14811 16.6357 2.99805 17.057 2.99805 18.0707V22.0039H17.7549C17.7549 22.0039 17.7549 19.6772 17.7549 19.0548C17.7545 18.13 15.9636 17.2593 13.8563 16.3637C11.7552 15.4711 11.084 14.7183 11.084 13.1065Z"
        fill="inherit"
      />
    </svg>
  ),
  iconCost: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="26"
      height="26"
      viewBox="0 0 26 26"
      fill="inherit"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M19.798 2.00391C19.073 2.00391 18.748 2.52611 18.748 3.17057V23.0039H23.998V3.17057C23.998 2.52611 23.4106 2.00391 22.6855 2.00391H19.798ZM11.923 9.0039C11.198 9.0039 10.873 9.5261 10.873 10.1706V23.0039H16.123V10.1706C16.123 9.5261 15.5356 9.0039 14.8105 9.0039H11.923ZM4.04805 16.0039C3.32302 16.0039 2.99805 16.5261 2.99805 17.1706V23.0039H8.24805V17.1706C8.24805 16.5261 7.66057 16.0039 6.93555 16.0039H4.04805Z"
        fill="inherit"
      />
    </svg>
  ),
  iconSustainability: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="26"
      height="26"
      viewBox="0 0 26 26"
      fill="inherit"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M17.2476 12.8091C17.6806 13.0697 18.2562 12.9619 18.549 12.5654L23.8286 5.40762C24.1285 5.0012 24.0197 4.44396 23.5863 4.16287C23.1522 3.88158 22.5581 3.98358 22.2582 4.39L17.5036 10.8359L12.3405 7.72495C12.1267 7.59627 11.8671 7.55318 11.6185 7.60398C11.3703 7.65537 11.1544 7.7973 11.0183 7.99834L3.14683 19.6297C2.86417 20.047 2.99626 20.5999 3.44125 20.8645C3.59981 20.9588 3.77684 21.0039 3.95177 21.0039C4.26782 21.0039 4.57694 20.857 4.75859 20.5882L12.1158 9.71672L17.2476 12.8091Z"
        fill="inherit"
      />
    </svg>
  ),
  iconRevenue: (
    <svg
      width="26"
      height="26"
      viewBox="0 0 26 26"
      fill="inherit"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g id="25px / BMC / Revenue">
        <path
          id="Pie-chart"
          fillRule="evenodd"
          clipRule="evenodd"
          d="M2.99805 11.2112H12.2055V2.00391C7.38825 2.57568 3.56982 6.39457 2.99805 11.2112ZM14.8394 12.5898C14.8394 13.2828 14.2779 13.8446 13.5844 13.8446H3.01562C3.69191 19.0128 8.10711 23.0039 13.4594 23.0039C19.2794 23.0039 23.9984 18.2857 23.9984 12.465C23.9984 7.11333 20.0067 2.69716 14.8394 2.02089V12.5898Z"
          fill="inherit"
        />
      </g>
    </svg>
  ),
  iconTeam: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="149"
      height="134"
      viewBox="0 0 126 113"
      fill="none"
    >
      <path
        d="M23.8535 89.7085L23.8526 89.7076C21.9632 87.7516 19.4702 85.9873 17.1695 84.359C17.0563 84.2788 16.9436 84.1991 16.8314 84.1196C14.3835 82.3856 12.2472 80.8329 11.0573 79.2989L11.054 79.2948C10.0792 78.0542 9.13054 76.5547 8.16716 74.8198C-6.79851 47.5439 4.8716 17.119 32.9048 7.9006L32.641 7.09857L32.9048 7.90059C41.7073 5.0058 50.9207 2.73056 59.3475 1.68579C67.7945 0.638514 75.3609 0.839558 80.9231 2.81653C83.467 3.72267 86.0901 5.50841 88.7655 7.92453C91.4359 10.336 94.1185 13.3385 96.7863 16.629C99.4531 19.9182 102.091 23.4768 104.676 26.9968C104.974 27.403 105.272 27.8088 105.569 28.2136C107.841 31.3104 110.072 34.35 112.229 37.0968L112.229 37.0971C116.29 42.2613 119.74 48.7843 122.001 55.1658C124.27 61.5672 125.307 67.7217 124.651 72.1705L124.651 72.1717C124.112 75.8645 121.548 80.9783 118.367 85.9103C115.203 90.8148 111.519 95.4027 108.872 98.0238C104.52 102.321 97.2592 106.564 88.7916 109.153C80.3307 111.739 70.7448 112.65 61.7474 110.376C47.4408 106.746 34.5262 100.791 23.8535 89.7085Z"
        stroke="inherit"
        strokeWidth="1.68856"
      />
    </svg>
  ),
  funBMCsixth: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="128"
      height="280"
      viewBox="0 0 128 280"
      fill="inherit"
    >
      <path
        d="M-33.429 40.4218C-50.138 61.5571 -68.5021 108.715 -63.9978 149.503C-60.4411 181.497 -52.4496 210.362 -35.3114 233.398C-29.2604 241.559 -25.1915 255.652 -20.0276 261.043C-18.0182 263.173 -15.1963 265.384 -12.3807 267.376C32.0434 298.384 86.8948 267.946 108.215 202.579C121.411 162.125 130.934 118.048 126.104 92.6623C121.567 68.8867 92.244 45.7489 72.9593 25.3178C56.6053 7.9705 30.5934 -3.09675 14.4956 1.0634C1.03155 4.51695 -23.3065 27.6489 -33.429 40.4218Z"
        fill="inherit"
      />
    </svg>
  ),
  funBMCseventh: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="123"
      height="463"
      viewBox="0 0 123 463"
      fill="inherit"
    >
      <path
        d="M295.913 331.397C263.764 372.537 230.902 413.755 199.159 455.213C193.269 462.935 188.34 464.054 179.203 460.614C117.743 437.613 76.1121 395.656 54.6716 333.604C50.1153 320.404 43.7637 308.878 35.5444 297.674C28.5501 288.151 22.8728 277.833 17.1279 267.547C4.28949 244.615 -5.47357 220.912 6.19136 194.288C10.1383 185.338 11.7909 175.351 14.4808 165.782C20.492 144.164 28.2683 123.63 43.5145 106.255C57.9068 89.8793 72.1034 72.1761 84.2532 54.1216C100.264 30.3842 124.371 16.922 147.592 2.15172C152.917 -1.22759 154.577 0.611789 158.587 3.74342C236.716 64.9178 314.706 126.056 393.081 186.915C404.65 191.42 399.651 198.737 394.365 205.409C361.483 247.209 328.66 289.491 295.913 331.397Z"
        fill="inherit"
      />
    </svg>
  ),
  funTestingEighth: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="340"
      height="430"
      viewBox="0 0 340 430"
      fill="inherit"
    >
      <path
        d="M64.152 502.413C20.7229 469.074 -39.7657 384.885 -53.4829 302.56C-64.1974 237.973 -64.9758 177.721 -44.8864 124.084C-37.8093 105.09 -37.4246 75.1886 -30.5239 62.0713C-27.8561 56.9047 -24.2867 51.7545 -20.0062 46.4623C47.7662 -36.1883 169.408 -3.69996 245.824 114.266C293.119 187.273 334.958 269.205 339.63 321.434C343.98 370.357 300.902 430.018 275.294 479.589C253.589 521.669 209.815 556.081 176.836 555.787C149.266 555.593 90.4447 522.549 64.152 502.413Z"
        fill="inherit"
      />
    </svg>
  ),
  funTestingNineth: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="294"
      height="456"
      viewBox="0 0 294 456"
      fill="inherit"
    >
      <path
        d="M408.408 391.991C382.651 429.577 316.107 467.677 249.648 452.449C197.508 440.448 148.586 418.605 104.401 375.152C88.7549 359.807 64.4524 348.076 53.5858 335.153C49.3072 330.121 45.0145 324.054 40.5846 317.111C-28.6264 207.623 -5.94871 79.3643 87.5476 35.6144C145.411 8.5367 210.691 -8.87095 252.977 5.44596C292.587 18.8872 342.368 91.1706 383.419 139.464C418.266 180.42 447.557 243.978 448.326 281.965C449.01 313.74 423.962 369.218 408.408 391.991Z"
        fill="inherit"
      />
    </svg>
  ),
  funDesirabilityTenth: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="710"
      height="554"
      viewBox="0 0 710 554"
      fill="inherit"
    >
      <path
        d="M740.75 -56.3472C830.441 6.28692 938.975 170.023 936.139 335.279C933.801 464.932 909.514 586.929 838.047 697.882C812.828 737.169 798.926 797.8 776.681 825.16C768.04 835.931 757.243 846.77 744.679 857.978C546.253 1033.12 268.604 981.064 136.53 750.692C54.789 608.119 -9.99533 446.844 1.47078 341.546C12.2745 242.909 141.493 117.146 224.43 13.8047C294.754 -73.9154 414.682 -148.598 493.653 -151.737C559.692 -154.465 686.429 -94.17 740.75 -56.3472Z"
        fill="inherit"
      />
    </svg>
  ),
  funVPeleventh: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="68"
      height="122"
      viewBox="0 0 68 122"
      fill="inherit"
    >
      <path
        d="M47.6298 22.2408C57.9732 27.1538 59.8692 37.7564 64.0336 46.7551C66.6406 52.4109 67.7579 58.4213 67.5209 64.7694C67.2501 72.0629 67.6394 79.3732 67.5379 86.6667C67.2839 104.006 61.0373 119.217 50.3892 132.656C45.9031 138.329 42.4835 144.593 38.9962 150.823C37.1171 154.216 34.8317 155.077 29.9224 154.452C16.3118 152.697 2.51496 152.815 -11.1126 154.402C-17.173 155.111 -18.5781 154.25 -18.5781 150.012C-18.4935 101.423 -18.4935 52.8499 -18.5781 4.26031C-18.5781 1.25513 -18.0026 0.292786 -14.7015 0.174606C-0.819983 -0.34877 11.1147 4.68239 22.3045 12.1785C26.6044 15.0655 47.6298 22.2408 47.6298 22.2408Z"
        fill="inherit"
      />
    </svg>
  ),
  funVPtwelveth: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="135"
      height="202"
      viewBox="0 0 135 202"
      fill="inherit"
    >
      <path
        d="M178.56 190.439C158.389 201.723 117.258 207.273 86.0976 191.503C61.6606 179.108 40.7013 163.245 26.1874 139.428C21.0403 131.011 10.7925 122.779 7.63936 116.027C6.38736 113.39 5.32085 110.338 4.34708 106.916C-10.6769 53.0374 24.7963 5.03242 80.7651 1.14763C115.404 -1.25725 152.036 1.28637 171.001 13.172C188.761 24.3177 200.771 60.4832 212.781 85.7807C222.982 107.24 226.135 136.93 219.458 152.238C213.894 165.049 190.755 183.594 178.56 190.439Z"
        fill="inherit"
      />
    </svg>
  ),
  funCAthirteen: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="243"
      height="442"
      viewBox="0 0 243 442"
      fill="inherit"
    >
      <path
        d="M195.752 93.2624C225.171 139.406 253.722 238.746 238.447 320.766C226.418 385.097 206.19 442.222 168.95 485.751C155.797 501.179 145.593 529.037 134.617 539.004C130.341 542.947 124.46 546.899 118.625 550.41C26.6309 604.918 -76.0967 532.573 -107.567 395.668C-127.046 310.94 -138.751 219.553 -125.271 168.893C-112.619 121.449 -51.4744 80.0429 -10.4381 42.2164C24.3654 10.0953 77.111 -7.41678 108.014 4.11651C133.865 13.7102 177.925 65.3711 195.752 93.2624Z"
        fill="inherit"
      />
    </svg>
  ),
  funCAfourteen: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="917"
      height="899"
      viewBox="0 0 917 899"
      fill="inherit"
    >
      <path
        d="M1386.16 149.803C1468.39 264.594 1508.83 498.663 1393.91 675.996C1303.59 815.066 1187.99 934.343 1014.43 1016.94C953.096 1046.23 893.108 1104.55 843.904 1122.5C824.695 1129.62 802.452 1135.69 777.513 1141.23C384.894 1226.73 35.0759 1024.86 6.76694 706.344C-10.7577 509.219 7.77797 300.747 94.39 192.817C175.61 91.7476 439.153 23.4004 623.499 -44.9467C779.872 -103.002 996.234 -120.946 1107.78 -82.9465C1201.14 -51.2799 1336.28 80.4003 1386.16 149.803Z"
        fill="inherit"
      />
    </svg>
  ),
  funCRfifteenth: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="232"
      height="294"
      viewBox="0 0 232 294"
      fill="inherit"
    >
      <path
        d="M191.791 256.096C168.371 283.237 111.356 313.142 57.5665 306.696C15.3691 301.602 -23.5982 289.609 -57.3884 262.609C-69.3559 253.076 -88.661 246.519 -96.8388 238.354C-100.062 235.178 -103.236 231.297 -106.47 226.827C-156.948 156.301 -130.697 67.5434 -51.1672 32.193C-1.94761 10.3142 52.8033 -5.41287 86.7544 1.84268C118.556 8.65973 155.245 54.979 186.169 85.4643C212.422 111.316 232.766 152.901 231.151 178.746C229.834 200.361 205.939 239.655 191.791 256.096Z"
        fill="inherit"
      />
    </svg>
  ),
  funCRsixteenth: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="66"
      height="140"
      viewBox="0 0 66 140"
      fill="inherit"
    >
      <path
        d="M151.751 115.527C142.207 129.444 117.553 143.553 92.9318 137.916C73.6151 133.473 55.4907 125.387 39.1217 109.299C33.3255 103.617 24.3221 99.2744 20.2965 94.4897C18.7115 92.6266 17.1212 90.3802 15.4802 87.8098C-10.1589 47.2718 -1.75449 -0.218365 32.8852 -16.4194C54.3232 -26.4465 78.5087 -32.8933 94.1746 -27.5932C108.849 -22.6173 127.291 4.14558 142.498 22.0259C155.407 37.1899 166.258 60.7223 166.542 74.7875C166.795 86.5525 157.514 107.095 151.751 115.527Z"
        fill="inherit"
      />
    </svg>
  ),
  funCRget: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="62"
      height="36"
      viewBox="0 0 62 36"
      fill="inherit"
    >
      <path
        d="M0.515625 2.68389C0.515625 1.56205 1.58939 0.752102 2.66807 1.0603L20.7784 6.23467V21.6729L2.66807 26.8473C1.58939 27.1555 0.515625 26.3456 0.515625 25.2237V2.68389Z"
        fill="inherit"
        className="get"
      />
      <path
        d="M41.041 6.23467L59.1513 1.0603C60.23 0.752103 61.3038 1.56204 61.3038 2.68389V25.2237C61.3038 26.3456 60.23 27.1555 59.1513 26.8473L41.041 21.6729V6.23467Z"
        fill="inherit"
      />
      <rect
        x="20.7793"
        y="6.23633"
        width="20.2627"
        height="15.4383"
        fill="inherit"
      />
      <path
        d="M14.1094 27.4636L14.1094 31.6842M14.1094 27.4636L18.3316 27.463M14.1094 27.4636C14.1094 27.4636 20.0205 35.0611 30.9983 35.0615C41.976 35.062 47.8871 27.4636 47.8871 27.4636"
        stroke="inherit"
        fill="none"
        strokeWidth="1.68856"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  funCRkeep: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="62"
      height="36"
      viewBox="0 0 62 36"
      fill="inherit"
    >
      <path
        d="M0.515625 2.68389C0.515625 1.56205 1.58939 0.752102 2.66807 1.0603L20.7784 6.23467V21.6729L2.66807 26.8473C1.58939 27.1555 0.515625 26.3456 0.515625 25.2237V2.68389Z"
        fill="inherit"
      />
      <path
        d="M41.041 6.23467L59.1513 1.0603C60.23 0.752103 61.3038 1.56204 61.3038 2.68389V25.2237C61.3038 26.3456 60.23 27.1555 59.1513 26.8473L41.041 21.6729V6.23467Z"
        fill="inherit"
      />
      <rect
        x="20.7793"
        y="6.23633"
        width="20.2627"
        height="15.4383"
        fill="inherit"
        className="keep"
      />
      <path
        d="M14.1094 27.4636L14.1094 31.6842M14.1094 27.4636L18.3316 27.463M14.1094 27.4636C14.1094 27.4636 20.0205 35.0611 30.9983 35.0615C41.976 35.062 47.8871 27.4636 47.8871 27.4636"
        stroke="inherit"
        fill="none"
        strokeWidth="1.68856"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  funCRreferral: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="62"
      height="36"
      viewBox="0 0 62 36"
      fill="inherit"
    >
      <path
        d="M0.515625 2.68389C0.515625 1.56205 1.58939 0.752102 2.66807 1.0603L20.7784 6.23467V21.6729L2.66807 26.8473C1.58939 27.1555 0.515625 26.3456 0.515625 25.2237V2.68389Z"
        fill="inherit"
      />
      <path
        d="M41.041 6.23467L59.1513 1.0603C60.23 0.752103 61.3038 1.56204 61.3038 2.68389V25.2237C61.3038 26.3456 60.23 27.1555 59.1513 26.8473L41.041 21.6729V6.23467Z"
        fill="inherit"
      />
      <rect
        x="20.7793"
        y="6.23633"
        width="20.2627"
        height="15.4383"
        fill="inherit"
      />
      <path
        d="M14.1094 27.4636L14.1094 31.6842M14.1094 27.4636L18.3316 27.463M14.1094 27.4636C14.1094 27.4636 20.0205 35.0611 30.9983 35.0615C41.976 35.062 47.8871 27.4636 47.8871 27.4636"
        stroke="inherit"
        fill="none"
        strokeWidth="1.68856"
        strokeLinecap="round"
        strokeLinejoin="round"
        className="referral"
      />
    </svg>
  ),
  funCRgrow: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="62"
      height="36"
      viewBox="0 0 62 36"
      fill="inherit"
    >
      <path
        d="M0.515625 2.68389C0.515625 1.56205 1.58939 0.752102 2.66807 1.0603L20.7784 6.23467V21.6729L2.66807 26.8473C1.58939 27.1555 0.515625 26.3456 0.515625 25.2237V2.68389Z"
        fill="inherit"
      />
      <path
        d="M41.041 6.23467L59.1513 1.0603C60.23 0.752103 61.3038 1.56204 61.3038 2.68389V25.2237C61.3038 26.3456 60.23 27.1555 59.1513 26.8473L41.041 21.6729V6.23467Z"
        fill="inherit"
        className="grow"
      />
      <rect
        x="20.7793"
        y="6.23633"
        width="20.2627"
        height="15.4383"
        fill="inherit"
      />
      <path
        d="M14.1094 27.4636L14.1094 31.6842M14.1094 27.4636L18.3316 27.463M14.1094 27.4636C14.1094 27.4636 20.0205 35.0611 30.9983 35.0615C41.976 35.062 47.8871 27.4636 47.8871 27.4636"
        stroke="inherit"
        fill="none"
        strokeWidth="1.68856"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  funCSfirst: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="128"
      height="178"
      viewBox="0 0 128 178"
      fill="inherit"
    >
      <path
        d="M-33.429 40.3532C-50.138 61.4885 -68.5021 108.647 -63.9978 149.435C-60.4411 181.429 -52.4496 210.294 -35.3114 233.329C-29.2604 241.491 -25.1915 255.583 -20.0276 260.975C-18.0182 263.104 -15.1963 265.315 -12.3807 267.308C32.0434 298.315 86.8948 267.877 108.215 202.511C121.411 162.056 130.934 117.979 126.104 92.5937C121.567 68.8181 92.244 45.6803 72.9593 25.2492C56.6053 7.9019 30.5934 -3.16535 14.4956 0.994801C1.03155 4.44835 -23.3065 27.5803 -33.429 40.3532Z"
        fill="inherit"
      />
    </svg>
  ),
  funCSsecond: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="97"
      height="175"
      viewBox="0 0 97 175"
      fill="inherit"
    >
      <path
        d="M156.172 105.805C139.228 127.488 121.907 149.212 105.177 171.063C102.073 175.133 99.4737 175.722 94.655 173.906C62.2401 161.767 40.2778 139.637 28.9583 106.917C26.5528 99.9564 23.2009 93.8786 18.8642 87.9695C15.1738 82.9473 12.1778 77.5061 9.14613 72.0816C2.37107 59.9889 -2.78237 47.49 3.36323 33.4554C5.44265 28.7377 6.31196 23.4725 7.72843 18.428C10.8937 7.03208 14.99 -3.79253 23.0261 -12.95C30.6121 -21.5805 38.0947 -30.911 44.4978 -40.4272C52.9355 -52.9388 65.6452 -60.0312 77.8874 -67.8135C80.6946 -69.594 81.5706 -68.6239 83.6854 -66.972C124.899 -34.7026 166.038 -2.45217 207.381 29.6512C213.483 32.0286 210.848 35.8853 208.062 39.4016C190.731 61.4327 173.432 83.7179 156.172 105.805Z"
        fill="inherit"
      />
    </svg>
  ),
  funChannelsFirst: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="98"
      height="175"
      viewBox="0 0 98 175"
      fill="inherit"
    >
      <path
        d="M-56.2437 107.632C-38.5527 128.711 -20.4846 149.817 -3.00155 171.071C0.242687 175.03 2.8609 175.528 7.61321 173.545C39.5846 160.282 60.7611 137.4 70.9316 104.304C73.0927 97.2643 76.2304 91.0732 80.3582 85.0164C83.871 79.8685 86.6753 74.3261 89.5157 68.7991C95.8646 56.4774 100.579 43.8062 93.9468 29.9947C91.704 25.3524 90.6514 20.1208 89.0597 15.1287C85.4986 3.85019 81.027 -6.82489 72.6761 -15.6964C64.7934 -24.0569 56.9897 -33.1207 50.2583 -42.4077C41.3891 -54.6172 28.4395 -61.2619 15.9331 -68.6122C13.0654 -70.2937 12.2239 -69.2936 10.168 -67.5689C-29.8936 -33.8811 -69.8827 -0.214864 -110.08 33.3115C-116.095 35.9003 -113.327 39.6628 -110.42 43.0797C-92.3306 64.4927 -74.2636 86.1606 -56.2437 107.632Z"
        fill="inherit"
      />
    </svg>
  ),
  funChannelsSecond: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="193"
      height="179"
      viewBox="0 0 193 179"
      fill="inherit"
    >
      <path
        d="M32.0827 40.9777C15.3737 62.113 -2.99036 109.271 1.51387 150.059C5.07065 182.053 13.0621 210.918 30.2003 233.953C36.2513 242.115 40.3203 256.208 45.4842 261.599C47.4936 263.729 50.3154 265.94 53.131 267.932C97.5552 298.94 152.406 268.501 173.727 203.135C186.923 162.681 196.446 118.604 191.616 93.2182C187.079 69.4426 157.756 46.3048 138.471 25.8738C122.117 8.52641 96.1051 -2.54084 80.0074 1.61931C66.5433 5.07286 42.2052 28.2048 32.0827 40.9777Z"
        fill="inherit"
      />
    </svg>
  ),
  funFeasibility: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="692"
      height="403"
      viewBox="0 0 692 403"
      fill="inherit"
    >
      <path
        d="M842.633 27.6403C911.801 112.387 971.473 299.537 923.596 457.734C885.925 581.818 829.231 692.542 730.169 779.758C695.176 810.664 665.237 865.192 636.363 885.436C625.108 893.438 611.76 900.916 596.612 908.267C357.882 1022.56 105.014 896.654 40.9025 638.974C1.22192 479.499 -17.0372 306.665 22.7612 208.503C60.1024 116.567 218.766 30.8775 326.783 -45.8837C418.398 -111.062 554.169 -150.152 630.995 -131.605C695.268 -116.193 800.711 -23.5793 842.633 27.6403Z"
        fill="inherit"
      />
    </svg>
  ),
  funKeyFirst: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="76"
      height="299"
      viewBox="0 0 76 299"
      fill="inherit"
    >
      <path
        d="M30.7375 282.609C10.5665 299.346 -30.5639 307.578 -61.7246 284.187C-86.1617 265.804 -107.121 242.276 -121.635 206.95C-126.782 194.466 -137.03 182.256 -140.183 172.242C-141.435 168.332 -142.501 163.804 -143.475 158.729C-158.499 78.8164 -123.026 7.61577 -67.0572 1.85386C-32.4187 -1.71303 4.21375 2.05965 23.1791 19.6883C40.9389 36.2195 52.9488 89.86 64.9586 127.381C75.1601 159.209 78.3132 203.246 71.6359 225.951C66.0715 244.951 42.9328 272.457 30.7375 282.609Z"
        fill="inherit"
      />
    </svg>
  ),
  funKeySecond: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="51"
      height="425"
      viewBox="0 0 51 425"
      fill="inherit"
    >
      <path
        d="M178.005 401.898C157.834 425.7 116.704 437.406 85.543 404.142C61.1059 377.999 40.1466 344.541 25.6327 294.304C20.4856 276.55 10.2378 259.187 7.08467 244.945C5.83268 239.384 4.76616 232.946 3.79239 225.728C-11.2315 112.085 24.2416 10.831 80.2104 2.637C114.849 -2.43547 151.481 2.92964 170.447 27.9993C188.206 51.5082 200.216 127.79 212.226 181.149C222.428 226.411 225.581 289.036 218.904 321.324C213.339 348.345 190.2 387.461 178.005 401.898Z"
        fill="inherit"
      />
    </svg>
  ),
  funViability: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="692"
      height="360"
      viewBox="0 0 692 360"
      fill="inherit"
    >
      <path
        d="M842.633 28.1071C911.801 112.854 971.473 300.004 923.596 458.201C885.925 582.285 829.231 693.009 730.169 780.225C695.176 811.131 665.237 865.659 636.363 885.903C625.108 893.905 611.76 901.383 596.612 908.734C357.882 1023.02 105.014 897.121 40.9025 639.441C1.22192 479.966 -17.0372 307.132 22.7612 208.969C60.1024 117.034 218.766 31.3443 326.783 -45.4169C418.398 -110.595 554.169 -149.685 630.995 -131.138C695.268 -115.727 800.711 -23.1125 842.633 28.1071Z"
        fill="inherit"
      />
    </svg>
  ),
  funFinancial: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="278"
      height="225"
      viewBox="0 0 278 225"
      fill="inherit"
    >
      <path
        d="M269.95 62.795C281.252 86.3558 281.103 130.309 254.452 158.93C233.517 181.369 208.61 199.389 174.314 208.863C162.19 212.229 149.38 220.928 139.833 222.617C136.102 223.298 131.852 223.689 127.127 223.897C52.8013 226.859 -4.48589 178.829 0.589368 119.878C3.72958 83.3934 13.8086 46.0002 33.0673 29.1163C51.1225 13.3092 101.365 9.32484 137.17 2.79505C167.544 -2.75833 207.565 0.92554 226.68 11.4353C242.682 20.2061 263.087 48.545 269.95 62.795Z"
        fill="inherit"
      />
    </svg>
  ),
  funForecastFirst: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="213"
      height="225"
      viewBox="0 0 213 225"
      fill="inherit"
    >
      <path
        d="M205.684 63.0811C216.987 86.642 216.837 130.595 190.187 159.216C169.252 181.655 144.344 199.676 110.048 209.149C97.9246 212.515 85.114 221.214 75.5671 222.903C71.836 223.584 67.5859 223.975 62.8612 224.183C-11.4643 227.145 -68.7515 179.115 -63.6763 120.164C-60.536 83.6796 -50.4571 46.2864 -31.1983 29.4024C-13.1431 13.5954 37.0996 9.61097 72.9039 3.08118C103.278 -2.4722 143.299 1.21167 162.415 11.7214C178.416 20.4922 198.822 48.8312 205.684 63.0811Z"
        fill="inherit"
      />
    </svg>
  ),
  funForecastSecond: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="101"
      height="235"
      viewBox="0 0 101 235"
      fill="inherit"
    >
      <path
        d="M27.4166 205.832C10.0968 189.752 -6.43744 151.932 2.52335 117.523C9.57945 90.5308 21.26 65.8721 43.1529 45.0984C50.8852 37.7398 57.1084 25.546 63.5619 20.5782C66.076 18.6186 69.0855 16.7169 72.5169 14.7974C126.616 -15.1282 187.367 5.03496 205.921 57.5556C217.405 90.0599 224.078 125.901 216.164 147.503C208.736 167.736 172.917 189.668 148.789 208.468C128.325 224.429 97.1962 236.008 79.0142 234.02C63.8044 232.379 37.9118 215.547 27.4166 205.832Z"
        fill="inherit"
      />
    </svg>
  ),
  funGraph: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="224"
      height="237"
      viewBox="0 0 224 237"
      fill="inherit"
    >
      <path
        d="M-93.3714 183.506C-105.425 138.531 -117.245 93.4407 -129.742 48.5843C-132.083 40.2456 -130.662 35.4875 -123.296 30.8245C-73.8442 -0.61888 -21.1442 -8.30268 34.639 9.71562C46.5028 13.5518 58.1355 16.1313 70.5459 16.2875C81.0984 16.4139 91.7563 16.9341 102.181 18.3604C125.439 21.5175 146.785 28.1928 159.5 50.7872C163.761 58.4007 170.697 64.559 176.075 71.6094C188.259 87.4898 197.972 104.402 202.165 124.585C206.105 143.624 211.231 162.555 217.574 180.897C225.894 205.038 223.293 229.257 221.34 253.724C220.887 259.331 218.1 260.763 213.711 261.939C128.071 284.776 42.4322 307.613 -43.1153 330.794C-52.5487 336.619 -54.6723 328.3 -56.5879 320.955C-68.7176 275.104 -81.0938 229.318 -93.3714 183.506Z"
        fill="inherit"
      />
    </svg>
  ),
  funSustainabilityFirst: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="242"
      height="436"
      viewBox="0 0 242 436"
      fill="inherit"
    >
      <path
        d="M194.908 92.8185C224.327 138.962 252.879 238.302 237.603 320.322C225.574 384.653 205.346 441.779 168.106 485.308C154.954 500.735 144.75 528.593 133.774 538.56C129.498 542.503 123.616 546.455 117.781 549.966C25.7871 604.474 -76.9405 532.129 -108.411 395.225C-127.889 310.496 -139.595 219.109 -126.115 168.449C-113.463 121.005 -52.3182 79.599 -11.2818 41.7725C23.5217 9.65144 76.2673 -7.86063 107.17 3.67267C133.021 13.2663 177.081 64.9272 194.908 92.8185Z"
        fill="inherit"
      />
    </svg>
  ),
  funSustainabilitySecond: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="918"
      height="894"
      viewBox="0 0 918 894"
      fill="inherit"
    >
      <path
        d="M1386.31 150.359C1468.54 265.15 1508.98 499.219 1394.06 676.552C1303.74 815.621 1188.15 934.899 1014.59 1017.5C953.253 1046.79 893.264 1105.11 844.061 1123.05C824.851 1130.18 802.608 1136.25 777.669 1141.79C385.051 1227.29 35.2322 1025.41 6.92319 706.899C-10.6014 509.775 7.93422 301.303 94.5463 193.372C175.766 92.3032 439.309 23.9561 623.655 -44.391C780.028 -102.446 996.39 -120.391 1107.94 -82.3909C1201.29 -50.7242 1336.43 80.9559 1386.31 150.359Z"
        fill="inherit"
      />
    </svg>
  ),
  incomplete: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="inherit"
    >
      <path
        d="M6 12C6 11.5858 6.33579 11.25 6.75 11.25H17.25C17.6642 11.25 18 11.5858 18 12C18 12.4142 17.6642 12.75 17.25 12.75H6.75C6.33579 12.75 6 12.4142 6 12Z"
        fill="inherit"
        stroke="inherit"
      />
    </svg>
  ),
  summary: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="86"
      height="71"
      viewBox="0 0 86 71"
      fill="inherit"
    >
      <path
        d="M0 49.8323C0 63.2826 8.77551 71 20.1837 71C30.0561 71 38.1735 63.5031 38.1735 54.2422C38.1735 43.2174 28.9592 36.823 19.5255 36.823C20.4031 22.7112 28.7398 14.5528 39.7092 6.83541L34.0051 0C20.1837 7.4969 0 25.7981 0 49.8323ZM46.2908 49.8323C46.2908 63.2826 55.0663 71 66.4745 71C76.3469 71 84.4643 63.5031 84.4643 54.2422C84.4643 43.2174 75.25 36.823 65.8163 36.823C66.6939 22.7112 75.0306 14.5528 86 6.83541L80.2959 0C66.4745 7.4969 46.2908 25.7981 46.2908 49.8323Z"
        fill="inherit"
      />
    </svg>
  ),
  headerComment: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="60"
      height="60"
      viewBox="0 0 60 60"
      fill="inherit"
    >
      <circle cx="30" cy="30" r="30" fill="white" />
      <path
        d="M30 60C34.1247 60 37.998 59.2153 41.6197 57.6459C45.2415 56.0966 48.4306 53.9437 51.1871 51.1871C53.9437 48.4306 56.0966 45.2415 57.6459 41.6197C59.2153 37.998 60 34.1247 60 30C60 25.8954 59.2153 22.0322 57.6459 18.4105C56.0966 14.7887 53.9336 11.5996 51.1569 8.84306C48.4004 6.08652 45.2113 3.92354 41.5895 2.35412C37.9678 0.784708 34.0946 0 29.9698 0C25.8853 0 22.0322 0.784708 18.4105 2.35412C14.7887 3.92354 11.5895 6.08652 8.81288 8.84306C6.05634 11.5996 3.89336 14.7887 2.32394 18.4105C0.774648 22.0322 0 25.8954 0 30C0 34.1247 0.784708 37.998 2.35412 41.6197C3.92354 45.2415 6.08652 48.4306 8.84306 51.1871C11.5996 53.9437 14.7887 56.0966 18.4105 57.6459C22.0322 59.2153 25.8954 60 30 60ZM30.0302 41.1972C29.7083 41.1972 29.3863 41.1972 29.0644 41.1972C28.7626 41.1972 28.4708 41.1771 28.1891 41.1368C27.9276 41.1167 27.6358 41.2072 27.3139 41.4085C25.8652 42.2938 24.4769 43.0282 23.1489 43.6117C21.8209 44.1952 20.7545 44.4869 19.9497 44.4869C19.2857 44.4869 18.8732 44.2656 18.7123 43.8229C18.5513 43.3803 18.6821 42.9276 19.1046 42.4648C19.4064 42.0825 19.7284 41.66 20.0704 41.1972C20.4326 40.7143 20.7545 40.2113 21.0362 39.6881C21.2374 39.2656 21.1871 38.9638 20.8853 38.7827C18.9738 37.5755 17.4245 36.0865 16.2374 34.3159C15.0704 32.5252 14.4869 30.5634 14.4869 28.4306C14.4869 26.0563 15.171 23.9034 16.5392 21.9718C17.9276 20.0201 19.7887 18.4809 22.1227 17.3541C24.4769 16.2072 27.1127 15.6338 30.0302 15.6338C32.9477 15.6338 35.5734 16.2072 37.9074 17.3541C40.2616 18.4809 42.1227 20.0201 43.4909 21.9718C44.8793 23.9034 45.5734 26.0563 45.5734 28.4306C45.5734 30.7847 44.8793 32.9376 43.4909 34.8893C42.1227 36.8209 40.2616 38.3602 37.9074 39.507C35.5734 40.6338 32.9477 41.1972 30.0302 41.1972Z"
        fill="inherit"
      />
    </svg>
  ),
  defaultUserAvatar: (
    <svg
      width="40"
      height="40"
      viewBox="0 0 40 40"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_13231_42232)">
        <rect width="40" height="40" fill="white" />
        <rect width="40" height="40" fill="#FFC305" />
        <path
          d="M7.5 35C7.5 35 5 35 5 32.5C5 30 7.5 22.5 20 22.5C32.5 22.5 35 30 35 32.5C35 35 32.5 35 32.5 35H7.5ZM20 20C21.9891 20 23.8968 19.2098 25.3033 17.8033C26.7098 16.3968 27.5 14.4891 27.5 12.5C27.5 10.5109 26.7098 8.60322 25.3033 7.1967C23.8968 5.79018 21.9891 5 20 5C18.0109 5 16.1032 5.79018 14.6967 7.1967C13.2902 8.60322 12.5 10.5109 12.5 12.5C12.5 14.4891 13.2902 16.3968 14.6967 17.8033C16.1032 19.2098 18.0109 20 20 20Z"
          fill="#FEDE6F"
        />
      </g>
      <defs>
        <clipPath id="clip0_13231_42232">
          <rect width="40" height="40" fill="white" />
        </clipPath>
      </defs>
    </svg>
  ),
  modalFirstSvg: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="155"
      height="255"
      viewBox="0 0 155 255"
      fill="inherit"
    >
      <path
        d="M115.674 39.6281C136.088 48.4363 139.83 67.4451 148.05 83.5783C153.195 93.7183 155.4 104.494 154.932 115.875C154.398 128.951 155.166 142.058 154.966 155.134C154.465 186.22 142.136 213.492 121.12 237.586C112.266 247.756 105.516 258.986 98.6335 270.155C94.9248 276.239 90.4142 277.783 80.7248 276.663C53.8617 273.515 26.6311 273.727 -0.265402 276.572C-12.2268 277.843 -15 276.299 -15 268.702C-14.8329 181.588 -14.8329 94.5054 -15 7.39194C-15 2.00409 -13.864 0.278778 -7.3487 0.0668945C20.049 -0.871429 43.6043 8.14865 65.6895 21.588C74.1761 26.7639 115.674 39.6281 115.674 39.6281Z"
        fill="inherit"
      />
    </svg>
  ),
  modalSecondSvg: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="147"
      height="164"
      viewBox="0 0 147 164"
      fill="inherit"
    >
      <path
        d="M192.8 152.255C170.911 164.498 126.279 170.519 92.4646 153.409C65.9467 139.963 43.2027 122.753 27.453 96.913C21.8676 87.7812 10.7472 78.8502 7.32552 71.5248C5.96691 68.6648 4.80958 65.3533 3.75289 61.6404C-12.5503 3.18733 25.9434 -48.8936 86.678 -53.1083C124.266 -55.7173 164.018 -52.9577 184.598 -40.0629C203.87 -27.9709 216.903 11.2654 229.935 38.7107C241.005 61.9916 244.427 94.2035 237.181 110.811C231.143 124.71 206.034 144.829 192.8 152.255Z"
        fill="inherit"
      />
    </svg>
  ),
  closePortfolioModalIcon: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="15"
      height="16"
      viewBox="0 0 15 16"
      fill="inherit"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M15 2.01071L13.4893 0.5L7.5 6.48929L1.51071 0.5L0 2.01071L5.98929 8L0 13.9893L1.51071 15.5L7.5 9.51071L13.4893 15.5L15 13.9893L9.01071 8L15 2.01071Z"
        fill="inherit"
      />
    </svg>
  ),
  testStar: (
    <svg
      aria-hidden="true"
      viewBox="0 0 32 32"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      fill="inherit"
    >
      <path
        d="M32 12.408l-11.056-1.607-4.944-10.018-4.944 10.018-11.056 1.607 8 7.798-1.889 11.011 9.889-5.199 9.889 5.199-1.889-11.011 8-7.798z"
        fill="inherit"
      />
    </svg>
  ),
  addColor: (
    <svg viewBox="0 0 35 35" xmlns="http://www.w3.org/2000/svg">
      <path
        fill="#fff"
        d="M16 0.667c8.468 0 15.333 6.865 15.333 15.333s-6.865 15.333-15.333 15.333c-8.468 0-15.333-6.865-15.333-15.333s6.865-15.333 15.333-15.333z"
      />
      <path d="M16 20c-0.169 0-0.297-0.048-0.383-0.144-0.079-0.095-0.127-0.219-0.127-0.354 0-0.010 0-0.019 0.001-0.029l-0 0.001v-3.028h-2.983c-0.008 0-0.017 0.001-0.026 0.001-0.136 0-0.26-0.049-0.356-0.129l0.001 0.001c-0.085-0.085-0.128-0.207-0.128-0.367s0.043-0.281 0.128-0.367c0.095-0.079 0.219-0.127 0.354-0.127 0.010 0 0.019 0 0.029 0.001l-0.001-0h2.981v-2.933c0-0.169 0.041-0.297 0.127-0.381 0.085-0.096 0.213-0.144 0.383-0.144s0.297 0.048 0.383 0.144c0.085 0.084 0.127 0.212 0.127 0.381v2.933h2.981c0.16 0 0.28 0.043 0.365 0.127 0.096 0.085 0.144 0.208 0.144 0.367 0 0.16-0.048 0.281-0.144 0.367-0.084 0.085-0.207 0.128-0.365 0.128h-2.981v3.027c0 0.16-0.041 0.288-0.127 0.383-0.085 0.096-0.213 0.144-0.383 0.144z" />
      <path
        fill="none"
        strokeLinejoin="miter"
        strokeLinecap="butt"
        strokeMiterlimit="4"
        strokeWidth="1.3333"
        d="M16 0.667c8.468 0 15.333 6.865 15.333 15.333s-6.865 15.333-15.333 15.333c-8.468 0-15.333-6.865-15.333-15.333s6.865-15.333 15.333-15.333z"
      />
    </svg>
  ),
};

export default icons;
